import ue, { useLayoutEffect as _r, useEffect as F, useRef as J, useMemo as q, useCallback as te, useState as Y, createContext as ht, memo as an, useReducer as Cr, useContext as qe, forwardRef as ln, cloneElement as cn } from "react";
import { unstable_batchedUpdates as _t, createPortal as dn } from "react-dom";
var Ct = { exports: {} }, it = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ir;
function un() {
  if (ir) return it;
  ir = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.fragment");
  function r(n, o, s) {
    var i = null;
    if (s !== void 0 && (i = "" + s), o.key !== void 0 && (i = "" + o.key), "key" in o) {
      s = {};
      for (var a in o)
        a !== "key" && (s[a] = o[a]);
    } else s = o;
    return o = s.ref, {
      $$typeof: e,
      type: n,
      key: i,
      ref: o !== void 0 ? o : null,
      props: s
    };
  }
  return it.Fragment = t, it.jsx = r, it.jsxs = r, it;
}
var lt = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var lr;
function fn() {
  return lr || (lr = 1, process.env.NODE_ENV !== "production" && function() {
    function e(h) {
      if (h == null) return null;
      if (typeof h == "function")
        return h.$$typeof === y ? null : h.displayName || h.name || null;
      if (typeof h == "string") return h;
      switch (h) {
        case g:
          return "Fragment";
        case E:
          return "Profiler";
        case b:
          return "StrictMode";
        case T:
          return "Suspense";
        case A:
          return "SuspenseList";
        case Z:
          return "Activity";
      }
      if (typeof h == "object")
        switch (typeof h.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), h.$$typeof) {
          case S:
            return "Portal";
          case D:
            return (h.displayName || "Context") + ".Provider";
          case _:
            return (h._context.displayName || "Context") + ".Consumer";
          case N:
            var P = h.render;
            return h = h.displayName, h || (h = P.displayName || P.name || "", h = h !== "" ? "ForwardRef(" + h + ")" : "ForwardRef"), h;
          case k:
            return P = h.displayName || null, P !== null ? P : e(h.type) || "Memo";
          case M:
            P = h._payload, h = h._init;
            try {
              return e(h(P));
            } catch {
            }
        }
      return null;
    }
    function t(h) {
      return "" + h;
    }
    function r(h) {
      try {
        t(h);
        var P = !1;
      } catch {
        P = !0;
      }
      if (P) {
        P = console;
        var B = P.error, ee = typeof Symbol == "function" && Symbol.toStringTag && h[Symbol.toStringTag] || h.constructor.name || "Object";
        return B.call(
          P,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          ee
        ), t(h);
      }
    }
    function n(h) {
      if (h === g) return "<>";
      if (typeof h == "object" && h !== null && h.$$typeof === M)
        return "<...>";
      try {
        var P = e(h);
        return P ? "<" + P + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function o() {
      var h = j.A;
      return h === null ? null : h.getOwner();
    }
    function s() {
      return Error("react-stack-top-frame");
    }
    function i(h) {
      if (G.call(h, "key")) {
        var P = Object.getOwnPropertyDescriptor(h, "key").get;
        if (P && P.isReactWarning) return !1;
      }
      return h.key !== void 0;
    }
    function a(h, P) {
      function B() {
        me || (me = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          P
        ));
      }
      B.isReactWarning = !0, Object.defineProperty(h, "key", {
        get: B,
        configurable: !0
      });
    }
    function d() {
      var h = e(this.type);
      return we[h] || (we[h] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), h = this.props.ref, h !== void 0 ? h : null;
    }
    function c(h, P, B, ee, C, z, ce, ve) {
      return B = z.ref, h = {
        $$typeof: m,
        type: h,
        key: P,
        props: z,
        _owner: C
      }, (B !== void 0 ? B : null) !== null ? Object.defineProperty(h, "ref", {
        enumerable: !1,
        get: d
      }) : Object.defineProperty(h, "ref", { enumerable: !1, value: null }), h._store = {}, Object.defineProperty(h._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(h, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(h, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: ce
      }), Object.defineProperty(h, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: ve
      }), Object.freeze && (Object.freeze(h.props), Object.freeze(h)), h;
    }
    function f(h, P, B, ee, C, z, ce, ve) {
      var U = P.children;
      if (U !== void 0)
        if (ee)
          if (oe(U)) {
            for (ee = 0; ee < U.length; ee++)
              u(U[ee]);
            Object.freeze && Object.freeze(U);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else u(U);
      if (G.call(P, "key")) {
        U = e(h);
        var W = Object.keys(P).filter(function(Ae) {
          return Ae !== "key";
        });
        ee = 0 < W.length ? "{key: someKey, " + W.join(": ..., ") + ": ...}" : "{key: someKey}", le[U + ee] || (W = 0 < W.length ? "{" + W.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          ee,
          U,
          W,
          U
        ), le[U + ee] = !0);
      }
      if (U = null, B !== void 0 && (r(B), U = "" + B), i(P) && (r(P.key), U = "" + P.key), "key" in P) {
        B = {};
        for (var $ in P)
          $ !== "key" && (B[$] = P[$]);
      } else B = P;
      return U && a(
        B,
        typeof h == "function" ? h.displayName || h.name || "Unknown" : h
      ), c(
        h,
        U,
        z,
        C,
        o(),
        B,
        ce,
        ve
      );
    }
    function u(h) {
      typeof h == "object" && h !== null && h.$$typeof === m && h._store && (h._store.validated = 1);
    }
    var p = ue, m = Symbol.for("react.transitional.element"), S = Symbol.for("react.portal"), g = Symbol.for("react.fragment"), b = Symbol.for("react.strict_mode"), E = Symbol.for("react.profiler"), _ = Symbol.for("react.consumer"), D = Symbol.for("react.context"), N = Symbol.for("react.forward_ref"), T = Symbol.for("react.suspense"), A = Symbol.for("react.suspense_list"), k = Symbol.for("react.memo"), M = Symbol.for("react.lazy"), Z = Symbol.for("react.activity"), y = Symbol.for("react.client.reference"), j = p.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, G = Object.prototype.hasOwnProperty, oe = Array.isArray, ne = console.createTask ? console.createTask : function() {
      return null;
    };
    p = {
      "react-stack-bottom-frame": function(h) {
        return h();
      }
    };
    var me, we = {}, se = p["react-stack-bottom-frame"].bind(
      p,
      s
    )(), Ee = ne(n(s)), le = {};
    lt.Fragment = g, lt.jsx = function(h, P, B, ee, C) {
      var z = 1e4 > j.recentlyCreatedOwnerStacks++;
      return f(
        h,
        P,
        B,
        !1,
        ee,
        C,
        z ? Error("react-stack-top-frame") : se,
        z ? ne(n(h)) : Ee
      );
    }, lt.jsxs = function(h, P, B, ee, C) {
      var z = 1e4 > j.recentlyCreatedOwnerStacks++;
      return f(
        h,
        P,
        B,
        !0,
        ee,
        C,
        z ? Error("react-stack-top-frame") : se,
        z ? ne(n(h)) : Ee
      );
    };
  }()), lt;
}
var cr;
function gn() {
  return cr || (cr = 1, process.env.NODE_ENV === "production" ? Ct.exports = un() : Ct.exports = fn()), Ct.exports;
}
var l = gn();
function pn() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return q(
    () => (n) => {
      t.forEach((o) => o(n));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  );
}
const Mt = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u";
function rt(e) {
  const t = Object.prototype.toString.call(e);
  return t === "[object Window]" || // In Electron context the Window object serializes to [object global]
  t === "[object global]";
}
function Qt(e) {
  return "nodeType" in e;
}
function Re(e) {
  var t, r;
  return e ? rt(e) ? e : Qt(e) && (t = (r = e.ownerDocument) == null ? void 0 : r.defaultView) != null ? t : window : window;
}
function Jt(e) {
  const {
    Document: t
  } = Re(e);
  return e instanceof t;
}
function mt(e) {
  return rt(e) ? !1 : e instanceof Re(e).HTMLElement;
}
function Nr(e) {
  return e instanceof Re(e).SVGElement;
}
function nt(e) {
  return e ? rt(e) ? e.document : Qt(e) ? Jt(e) ? e : mt(e) || Nr(e) ? e.ownerDocument : document : document : document;
}
const ke = Mt ? _r : F;
function Lt(e) {
  const t = J(e);
  return ke(() => {
    t.current = e;
  }), te(function() {
    for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++)
      n[o] = arguments[o];
    return t.current == null ? void 0 : t.current(...n);
  }, []);
}
function hn() {
  const e = J(null), t = te((n, o) => {
    e.current = setInterval(n, o);
  }, []), r = te(() => {
    e.current !== null && (clearInterval(e.current), e.current = null);
  }, []);
  return [t, r];
}
function ft(e, t) {
  t === void 0 && (t = [e]);
  const r = J(e);
  return ke(() => {
    r.current !== e && (r.current = e);
  }, t), r;
}
function vt(e, t) {
  const r = J();
  return q(
    () => {
      const n = e(r.current);
      return r.current = n, n;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...t]
  );
}
function jt(e) {
  const t = Lt(e), r = J(null), n = te(
    (o) => {
      o !== r.current && t?.(o, r.current), r.current = o;
    },
    //eslint-disable-next-line
    []
  );
  return [r, n];
}
function Rt(e) {
  const t = J();
  return F(() => {
    t.current = e;
  }, [e]), t.current;
}
let Ft = {};
function xt(e, t) {
  return q(() => {
    if (t)
      return t;
    const r = Ft[e] == null ? 0 : Ft[e] + 1;
    return Ft[e] = r, e + "-" + r;
  }, [e, t]);
}
function Er(e) {
  return function(t) {
    for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++)
      n[o - 1] = arguments[o];
    return n.reduce((s, i) => {
      const a = Object.entries(i);
      for (const [d, c] of a) {
        const f = s[d];
        f != null && (s[d] = f + e * c);
      }
      return s;
    }, {
      ...t
    });
  };
}
const tt = /* @__PURE__ */ Er(1), gt = /* @__PURE__ */ Er(-1);
function mn(e) {
  return "clientX" in e && "clientY" in e;
}
function Pt(e) {
  if (!e)
    return !1;
  const {
    KeyboardEvent: t
  } = Re(e.target);
  return t && e instanceof t;
}
function vn(e) {
  if (!e)
    return !1;
  const {
    TouchEvent: t
  } = Re(e.target);
  return t && e instanceof t;
}
function At(e) {
  if (vn(e)) {
    if (e.touches && e.touches.length) {
      const {
        clientX: t,
        clientY: r
      } = e.touches[0];
      return {
        x: t,
        y: r
      };
    } else if (e.changedTouches && e.changedTouches.length) {
      const {
        clientX: t,
        clientY: r
      } = e.changedTouches[0];
      return {
        x: t,
        y: r
      };
    }
  }
  return mn(e) ? {
    x: e.clientX,
    y: e.clientY
  } : null;
}
const We = /* @__PURE__ */ Object.freeze({
  Translate: {
    toString(e) {
      if (!e)
        return;
      const {
        x: t,
        y: r
      } = e;
      return "translate3d(" + (t ? Math.round(t) : 0) + "px, " + (r ? Math.round(r) : 0) + "px, 0)";
    }
  },
  Scale: {
    toString(e) {
      if (!e)
        return;
      const {
        scaleX: t,
        scaleY: r
      } = e;
      return "scaleX(" + t + ") scaleY(" + r + ")";
    }
  },
  Transform: {
    toString(e) {
      if (e)
        return [We.Translate.toString(e), We.Scale.toString(e)].join(" ");
    }
  },
  Transition: {
    toString(e) {
      let {
        property: t,
        duration: r,
        easing: n
      } = e;
      return t + " " + r + "ms " + n;
    }
  }
}), dr = "a,frame,iframe,input:not([type=hidden]):not(:disabled),select:not(:disabled),textarea:not(:disabled),button:not(:disabled),*[tabindex]";
function xn(e) {
  return e.matches(dr) ? e : e.querySelector(dr);
}
const bn = {
  display: "none"
};
function yn(e) {
  let {
    id: t,
    value: r
  } = e;
  return ue.createElement("div", {
    id: t,
    style: bn
  }, r);
}
function wn(e) {
  let {
    id: t,
    announcement: r,
    ariaLiveType: n = "assertive"
  } = e;
  const o = {
    position: "fixed",
    top: 0,
    left: 0,
    width: 1,
    height: 1,
    margin: -1,
    border: 0,
    padding: 0,
    overflow: "hidden",
    clip: "rect(0 0 0 0)",
    clipPath: "inset(100%)",
    whiteSpace: "nowrap"
  };
  return ue.createElement("div", {
    id: t,
    style: o,
    role: "status",
    "aria-live": n,
    "aria-atomic": !0
  }, r);
}
function Dn() {
  const [e, t] = Y("");
  return {
    announce: te((n) => {
      n != null && t(n);
    }, []),
    announcement: e
  };
}
const Sr = /* @__PURE__ */ ht(null);
function _n(e) {
  const t = qe(Sr);
  F(() => {
    if (!t)
      throw new Error("useDndMonitor must be used within a children of <DndContext>");
    return t(e);
  }, [e, t]);
}
function Cn() {
  const [e] = Y(() => /* @__PURE__ */ new Set()), t = te((n) => (e.add(n), () => e.delete(n)), [e]);
  return [te((n) => {
    let {
      type: o,
      event: s
    } = n;
    e.forEach((i) => {
      var a;
      return (a = i[o]) == null ? void 0 : a.call(i, s);
    });
  }, [e]), t];
}
const Nn = {
  draggable: `
    To pick up a draggable item, press the space bar.
    While dragging, use the arrow keys to move the item.
    Press space again to drop the item in its new position, or press escape to cancel.
  `
}, En = {
  onDragStart(e) {
    let {
      active: t
    } = e;
    return "Picked up draggable item " + t.id + ".";
  },
  onDragOver(e) {
    let {
      active: t,
      over: r
    } = e;
    return r ? "Draggable item " + t.id + " was moved over droppable area " + r.id + "." : "Draggable item " + t.id + " is no longer over a droppable area.";
  },
  onDragEnd(e) {
    let {
      active: t,
      over: r
    } = e;
    return r ? "Draggable item " + t.id + " was dropped over droppable area " + r.id : "Draggable item " + t.id + " was dropped.";
  },
  onDragCancel(e) {
    let {
      active: t
    } = e;
    return "Dragging was cancelled. Draggable item " + t.id + " was dropped.";
  }
};
function Sn(e) {
  let {
    announcements: t = En,
    container: r,
    hiddenTextDescribedById: n,
    screenReaderInstructions: o = Nn
  } = e;
  const {
    announce: s,
    announcement: i
  } = Dn(), a = xt("DndLiveRegion"), [d, c] = Y(!1);
  if (F(() => {
    c(!0);
  }, []), _n(q(() => ({
    onDragStart(u) {
      let {
        active: p
      } = u;
      s(t.onDragStart({
        active: p
      }));
    },
    onDragMove(u) {
      let {
        active: p,
        over: m
      } = u;
      t.onDragMove && s(t.onDragMove({
        active: p,
        over: m
      }));
    },
    onDragOver(u) {
      let {
        active: p,
        over: m
      } = u;
      s(t.onDragOver({
        active: p,
        over: m
      }));
    },
    onDragEnd(u) {
      let {
        active: p,
        over: m
      } = u;
      s(t.onDragEnd({
        active: p,
        over: m
      }));
    },
    onDragCancel(u) {
      let {
        active: p,
        over: m
      } = u;
      s(t.onDragCancel({
        active: p,
        over: m
      }));
    }
  }), [s, t])), !d)
    return null;
  const f = ue.createElement(ue.Fragment, null, ue.createElement(yn, {
    id: n,
    value: o.draggable
  }), ue.createElement(wn, {
    id: a,
    announcement: i
  }));
  return r ? dn(f, r) : f;
}
var ye;
(function(e) {
  e.DragStart = "dragStart", e.DragMove = "dragMove", e.DragEnd = "dragEnd", e.DragCancel = "dragCancel", e.DragOver = "dragOver", e.RegisterDroppable = "registerDroppable", e.SetDroppableDisabled = "setDroppableDisabled", e.UnregisterDroppable = "unregisterDroppable";
})(ye || (ye = {}));
function Tt() {
}
function Yt(e, t) {
  return q(
    () => ({
      sensor: e,
      options: t ?? {}
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e, t]
  );
}
function jn() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return q(
    () => [...t].filter((n) => n != null),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...t]
  );
}
const Me = /* @__PURE__ */ Object.freeze({
  x: 0,
  y: 0
});
function Rn(e, t) {
  return Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2));
}
function An(e, t) {
  const r = At(e);
  if (!r)
    return "0 0";
  const n = {
    x: (r.x - t.left) / t.width * 100,
    y: (r.y - t.top) / t.height * 100
  };
  return n.x + "% " + n.y + "%";
}
function Tn(e, t) {
  let {
    data: {
      value: r
    }
  } = e, {
    data: {
      value: n
    }
  } = t;
  return r - n;
}
function In(e, t) {
  let {
    data: {
      value: r
    }
  } = e, {
    data: {
      value: n
    }
  } = t;
  return n - r;
}
function ur(e) {
  let {
    left: t,
    top: r,
    height: n,
    width: o
  } = e;
  return [{
    x: t,
    y: r
  }, {
    x: t + o,
    y: r
  }, {
    x: t,
    y: r + n
  }, {
    x: t + o,
    y: r + n
  }];
}
function jr(e, t) {
  if (!e || e.length === 0)
    return null;
  const [r] = e;
  return r[t];
}
const On = (e) => {
  let {
    collisionRect: t,
    droppableRects: r,
    droppableContainers: n
  } = e;
  const o = ur(t), s = [];
  for (const i of n) {
    const {
      id: a
    } = i, d = r.get(a);
    if (d) {
      const c = ur(d), f = o.reduce((p, m, S) => p + Rn(c[S], m), 0), u = Number((f / 4).toFixed(4));
      s.push({
        id: a,
        data: {
          droppableContainer: i,
          value: u
        }
      });
    }
  }
  return s.sort(Tn);
};
function kn(e, t) {
  const r = Math.max(t.top, e.top), n = Math.max(t.left, e.left), o = Math.min(t.left + t.width, e.left + e.width), s = Math.min(t.top + t.height, e.top + e.height), i = o - n, a = s - r;
  if (n < o && r < s) {
    const d = t.width * t.height, c = e.width * e.height, f = i * a, u = f / (d + c - f);
    return Number(u.toFixed(4));
  }
  return 0;
}
const Rr = (e) => {
  let {
    collisionRect: t,
    droppableRects: r,
    droppableContainers: n
  } = e;
  const o = [];
  for (const s of n) {
    const {
      id: i
    } = s, a = r.get(i);
    if (a) {
      const d = kn(a, t);
      d > 0 && o.push({
        id: i,
        data: {
          droppableContainer: s,
          value: d
        }
      });
    }
  }
  return o.sort(In);
};
function Mn(e, t, r) {
  return {
    ...e,
    scaleX: t && r ? t.width / r.width : 1,
    scaleY: t && r ? t.height / r.height : 1
  };
}
function Ar(e, t) {
  return e && t ? {
    x: e.left - t.left,
    y: e.top - t.top
  } : Me;
}
function Ln(e) {
  return function(r) {
    for (var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), s = 1; s < n; s++)
      o[s - 1] = arguments[s];
    return o.reduce((i, a) => ({
      ...i,
      top: i.top + e * a.y,
      bottom: i.bottom + e * a.y,
      left: i.left + e * a.x,
      right: i.right + e * a.x
    }), {
      ...r
    });
  };
}
const Pn = /* @__PURE__ */ Ln(1);
function Tr(e) {
  if (e.startsWith("matrix3d(")) {
    const t = e.slice(9, -1).split(/, /);
    return {
      x: +t[12],
      y: +t[13],
      scaleX: +t[0],
      scaleY: +t[5]
    };
  } else if (e.startsWith("matrix(")) {
    const t = e.slice(7, -1).split(/, /);
    return {
      x: +t[4],
      y: +t[5],
      scaleX: +t[0],
      scaleY: +t[3]
    };
  }
  return null;
}
function $n(e, t, r) {
  const n = Tr(t);
  if (!n)
    return e;
  const {
    scaleX: o,
    scaleY: s,
    x: i,
    y: a
  } = n, d = e.left - i - (1 - o) * parseFloat(r), c = e.top - a - (1 - s) * parseFloat(r.slice(r.indexOf(" ") + 1)), f = o ? e.width / o : e.width, u = s ? e.height / s : e.height;
  return {
    width: f,
    height: u,
    top: c,
    right: d + f,
    bottom: c + u,
    left: d
  };
}
const zn = {
  ignoreTransform: !1
};
function ot(e, t) {
  t === void 0 && (t = zn);
  let r = e.getBoundingClientRect();
  if (t.ignoreTransform) {
    const {
      transform: c,
      transformOrigin: f
    } = Re(e).getComputedStyle(e);
    c && (r = $n(r, c, f));
  }
  const {
    top: n,
    left: o,
    width: s,
    height: i,
    bottom: a,
    right: d
  } = r;
  return {
    top: n,
    left: o,
    width: s,
    height: i,
    bottom: a,
    right: d
  };
}
function fr(e) {
  return ot(e, {
    ignoreTransform: !0
  });
}
function Un(e) {
  const t = e.innerWidth, r = e.innerHeight;
  return {
    top: 0,
    left: 0,
    right: t,
    bottom: r,
    width: t,
    height: r
  };
}
function Bn(e, t) {
  return t === void 0 && (t = Re(e).getComputedStyle(e)), t.position === "fixed";
}
function Vn(e, t) {
  t === void 0 && (t = Re(e).getComputedStyle(e));
  const r = /(auto|scroll|overlay)/;
  return ["overflow", "overflowX", "overflowY"].some((o) => {
    const s = t[o];
    return typeof s == "string" ? r.test(s) : !1;
  });
}
function $t(e, t) {
  const r = [];
  function n(o) {
    if (t != null && r.length >= t || !o)
      return r;
    if (Jt(o) && o.scrollingElement != null && !r.includes(o.scrollingElement))
      return r.push(o.scrollingElement), r;
    if (!mt(o) || Nr(o) || r.includes(o))
      return r;
    const s = Re(e).getComputedStyle(o);
    return o !== e && Vn(o, s) && r.push(o), Bn(o, s) ? r : n(o.parentNode);
  }
  return e ? n(e) : r;
}
function Ir(e) {
  const [t] = $t(e, 1);
  return t ?? null;
}
function qt(e) {
  return !Mt || !e ? null : rt(e) ? e : Qt(e) ? Jt(e) || e === nt(e).scrollingElement ? window : mt(e) ? e : null : null;
}
function Or(e) {
  return rt(e) ? e.scrollX : e.scrollLeft;
}
function kr(e) {
  return rt(e) ? e.scrollY : e.scrollTop;
}
function Xt(e) {
  return {
    x: Or(e),
    y: kr(e)
  };
}
var De;
(function(e) {
  e[e.Forward = 1] = "Forward", e[e.Backward = -1] = "Backward";
})(De || (De = {}));
function Mr(e) {
  return !Mt || !e ? !1 : e === document.scrollingElement;
}
function Lr(e) {
  const t = {
    x: 0,
    y: 0
  }, r = Mr(e) ? {
    height: window.innerHeight,
    width: window.innerWidth
  } : {
    height: e.clientHeight,
    width: e.clientWidth
  }, n = {
    x: e.scrollWidth - r.width,
    y: e.scrollHeight - r.height
  }, o = e.scrollTop <= t.y, s = e.scrollLeft <= t.x, i = e.scrollTop >= n.y, a = e.scrollLeft >= n.x;
  return {
    isTop: o,
    isLeft: s,
    isBottom: i,
    isRight: a,
    maxScroll: n,
    minScroll: t
  };
}
const Fn = {
  x: 0.2,
  y: 0.2
};
function Yn(e, t, r, n, o) {
  let {
    top: s,
    left: i,
    right: a,
    bottom: d
  } = r;
  n === void 0 && (n = 10), o === void 0 && (o = Fn);
  const {
    isTop: c,
    isBottom: f,
    isLeft: u,
    isRight: p
  } = Lr(e), m = {
    x: 0,
    y: 0
  }, S = {
    x: 0,
    y: 0
  }, g = {
    height: t.height * o.y,
    width: t.width * o.x
  };
  return !c && s <= t.top + g.height ? (m.y = De.Backward, S.y = n * Math.abs((t.top + g.height - s) / g.height)) : !f && d >= t.bottom - g.height && (m.y = De.Forward, S.y = n * Math.abs((t.bottom - g.height - d) / g.height)), !p && a >= t.right - g.width ? (m.x = De.Forward, S.x = n * Math.abs((t.right - g.width - a) / g.width)) : !u && i <= t.left + g.width && (m.x = De.Backward, S.x = n * Math.abs((t.left + g.width - i) / g.width)), {
    direction: m,
    speed: S
  };
}
function qn(e) {
  if (e === document.scrollingElement) {
    const {
      innerWidth: s,
      innerHeight: i
    } = window;
    return {
      top: 0,
      left: 0,
      right: s,
      bottom: i,
      width: s,
      height: i
    };
  }
  const {
    top: t,
    left: r,
    right: n,
    bottom: o
  } = e.getBoundingClientRect();
  return {
    top: t,
    left: r,
    right: n,
    bottom: o,
    width: e.clientWidth,
    height: e.clientHeight
  };
}
function Pr(e) {
  return e.reduce((t, r) => tt(t, Xt(r)), Me);
}
function Wn(e) {
  return e.reduce((t, r) => t + Or(r), 0);
}
function Hn(e) {
  return e.reduce((t, r) => t + kr(r), 0);
}
function $r(e, t) {
  if (t === void 0 && (t = ot), !e)
    return;
  const {
    top: r,
    left: n,
    bottom: o,
    right: s
  } = t(e);
  Ir(e) && (o <= 0 || s <= 0 || r >= window.innerHeight || n >= window.innerWidth) && e.scrollIntoView({
    block: "center",
    inline: "center"
  });
}
const Xn = [["x", ["left", "right"], Wn], ["y", ["top", "bottom"], Hn]];
class Zt {
  constructor(t, r) {
    this.rect = void 0, this.width = void 0, this.height = void 0, this.top = void 0, this.bottom = void 0, this.right = void 0, this.left = void 0;
    const n = $t(r), o = Pr(n);
    this.rect = {
      ...t
    }, this.width = t.width, this.height = t.height;
    for (const [s, i, a] of Xn)
      for (const d of i)
        Object.defineProperty(this, d, {
          get: () => {
            const c = a(n), f = o[s] - c;
            return this.rect[d] + f;
          },
          enumerable: !0
        });
    Object.defineProperty(this, "rect", {
      enumerable: !1
    });
  }
}
class ct {
  constructor(t) {
    this.target = void 0, this.listeners = [], this.removeAll = () => {
      this.listeners.forEach((r) => {
        var n;
        return (n = this.target) == null ? void 0 : n.removeEventListener(...r);
      });
    }, this.target = t;
  }
  add(t, r, n) {
    var o;
    (o = this.target) == null || o.addEventListener(t, r, n), this.listeners.push([t, r, n]);
  }
}
function Kn(e) {
  const {
    EventTarget: t
  } = Re(e);
  return e instanceof t ? e : nt(e);
}
function Wt(e, t) {
  const r = Math.abs(e.x), n = Math.abs(e.y);
  return typeof t == "number" ? Math.sqrt(r ** 2 + n ** 2) > t : "x" in t && "y" in t ? r > t.x && n > t.y : "x" in t ? r > t.x : "y" in t ? n > t.y : !1;
}
var Oe;
(function(e) {
  e.Click = "click", e.DragStart = "dragstart", e.Keydown = "keydown", e.ContextMenu = "contextmenu", e.Resize = "resize", e.SelectionChange = "selectionchange", e.VisibilityChange = "visibilitychange";
})(Oe || (Oe = {}));
function gr(e) {
  e.preventDefault();
}
function Gn(e) {
  e.stopPropagation();
}
var K;
(function(e) {
  e.Space = "Space", e.Down = "ArrowDown", e.Right = "ArrowRight", e.Left = "ArrowLeft", e.Up = "ArrowUp", e.Esc = "Escape", e.Enter = "Enter", e.Tab = "Tab";
})(K || (K = {}));
const zr = {
  start: [K.Space, K.Enter],
  cancel: [K.Esc],
  end: [K.Space, K.Enter, K.Tab]
}, Qn = (e, t) => {
  let {
    currentCoordinates: r
  } = t;
  switch (e.code) {
    case K.Right:
      return {
        ...r,
        x: r.x + 25
      };
    case K.Left:
      return {
        ...r,
        x: r.x - 25
      };
    case K.Down:
      return {
        ...r,
        y: r.y + 25
      };
    case K.Up:
      return {
        ...r,
        y: r.y - 25
      };
  }
};
class er {
  constructor(t) {
    this.props = void 0, this.autoScrollEnabled = !1, this.referenceCoordinates = void 0, this.listeners = void 0, this.windowListeners = void 0, this.props = t;
    const {
      event: {
        target: r
      }
    } = t;
    this.props = t, this.listeners = new ct(nt(r)), this.windowListeners = new ct(Re(r)), this.handleKeyDown = this.handleKeyDown.bind(this), this.handleCancel = this.handleCancel.bind(this), this.attach();
  }
  attach() {
    this.handleStart(), this.windowListeners.add(Oe.Resize, this.handleCancel), this.windowListeners.add(Oe.VisibilityChange, this.handleCancel), setTimeout(() => this.listeners.add(Oe.Keydown, this.handleKeyDown));
  }
  handleStart() {
    const {
      activeNode: t,
      onStart: r
    } = this.props, n = t.node.current;
    n && $r(n), r(Me);
  }
  handleKeyDown(t) {
    if (Pt(t)) {
      const {
        active: r,
        context: n,
        options: o
      } = this.props, {
        keyboardCodes: s = zr,
        coordinateGetter: i = Qn,
        scrollBehavior: a = "smooth"
      } = o, {
        code: d
      } = t;
      if (s.end.includes(d)) {
        this.handleEnd(t);
        return;
      }
      if (s.cancel.includes(d)) {
        this.handleCancel(t);
        return;
      }
      const {
        collisionRect: c
      } = n.current, f = c ? {
        x: c.left,
        y: c.top
      } : Me;
      this.referenceCoordinates || (this.referenceCoordinates = f);
      const u = i(t, {
        active: r,
        context: n.current,
        currentCoordinates: f
      });
      if (u) {
        const p = gt(u, f), m = {
          x: 0,
          y: 0
        }, {
          scrollableAncestors: S
        } = n.current;
        for (const g of S) {
          const b = t.code, {
            isTop: E,
            isRight: _,
            isLeft: D,
            isBottom: N,
            maxScroll: T,
            minScroll: A
          } = Lr(g), k = qn(g), M = {
            x: Math.min(b === K.Right ? k.right - k.width / 2 : k.right, Math.max(b === K.Right ? k.left : k.left + k.width / 2, u.x)),
            y: Math.min(b === K.Down ? k.bottom - k.height / 2 : k.bottom, Math.max(b === K.Down ? k.top : k.top + k.height / 2, u.y))
          }, Z = b === K.Right && !_ || b === K.Left && !D, y = b === K.Down && !N || b === K.Up && !E;
          if (Z && M.x !== u.x) {
            const j = g.scrollLeft + p.x, G = b === K.Right && j <= T.x || b === K.Left && j >= A.x;
            if (G && !p.y) {
              g.scrollTo({
                left: j,
                behavior: a
              });
              return;
            }
            G ? m.x = g.scrollLeft - j : m.x = b === K.Right ? g.scrollLeft - T.x : g.scrollLeft - A.x, m.x && g.scrollBy({
              left: -m.x,
              behavior: a
            });
            break;
          } else if (y && M.y !== u.y) {
            const j = g.scrollTop + p.y, G = b === K.Down && j <= T.y || b === K.Up && j >= A.y;
            if (G && !p.x) {
              g.scrollTo({
                top: j,
                behavior: a
              });
              return;
            }
            G ? m.y = g.scrollTop - j : m.y = b === K.Down ? g.scrollTop - T.y : g.scrollTop - A.y, m.y && g.scrollBy({
              top: -m.y,
              behavior: a
            });
            break;
          }
        }
        this.handleMove(t, tt(gt(u, this.referenceCoordinates), m));
      }
    }
  }
  handleMove(t, r) {
    const {
      onMove: n
    } = this.props;
    t.preventDefault(), n(r);
  }
  handleEnd(t) {
    const {
      onEnd: r
    } = this.props;
    t.preventDefault(), this.detach(), r();
  }
  handleCancel(t) {
    const {
      onCancel: r
    } = this.props;
    t.preventDefault(), this.detach(), r();
  }
  detach() {
    this.listeners.removeAll(), this.windowListeners.removeAll();
  }
}
er.activators = [{
  eventName: "onKeyDown",
  handler: (e, t, r) => {
    let {
      keyboardCodes: n = zr,
      onActivation: o
    } = t, {
      active: s
    } = r;
    const {
      code: i
    } = e.nativeEvent;
    if (n.start.includes(i)) {
      const a = s.activatorNode.current;
      return a && e.target !== a ? !1 : (e.preventDefault(), o?.({
        event: e.nativeEvent
      }), !0);
    }
    return !1;
  }
}];
function pr(e) {
  return !!(e && "distance" in e);
}
function hr(e) {
  return !!(e && "delay" in e);
}
class tr {
  constructor(t, r, n) {
    var o;
    n === void 0 && (n = Kn(t.event.target)), this.props = void 0, this.events = void 0, this.autoScrollEnabled = !0, this.document = void 0, this.activated = !1, this.initialCoordinates = void 0, this.timeoutId = null, this.listeners = void 0, this.documentListeners = void 0, this.windowListeners = void 0, this.props = t, this.events = r;
    const {
      event: s
    } = t, {
      target: i
    } = s;
    this.props = t, this.events = r, this.document = nt(i), this.documentListeners = new ct(this.document), this.listeners = new ct(n), this.windowListeners = new ct(Re(i)), this.initialCoordinates = (o = At(s)) != null ? o : Me, this.handleStart = this.handleStart.bind(this), this.handleMove = this.handleMove.bind(this), this.handleEnd = this.handleEnd.bind(this), this.handleCancel = this.handleCancel.bind(this), this.handleKeydown = this.handleKeydown.bind(this), this.removeTextSelection = this.removeTextSelection.bind(this), this.attach();
  }
  attach() {
    const {
      events: t,
      props: {
        options: {
          activationConstraint: r,
          bypassActivationConstraint: n
        }
      }
    } = this;
    if (this.listeners.add(t.move.name, this.handleMove, {
      passive: !1
    }), this.listeners.add(t.end.name, this.handleEnd), t.cancel && this.listeners.add(t.cancel.name, this.handleCancel), this.windowListeners.add(Oe.Resize, this.handleCancel), this.windowListeners.add(Oe.DragStart, gr), this.windowListeners.add(Oe.VisibilityChange, this.handleCancel), this.windowListeners.add(Oe.ContextMenu, gr), this.documentListeners.add(Oe.Keydown, this.handleKeydown), r) {
      if (n != null && n({
        event: this.props.event,
        activeNode: this.props.activeNode,
        options: this.props.options
      }))
        return this.handleStart();
      if (hr(r)) {
        this.timeoutId = setTimeout(this.handleStart, r.delay), this.handlePending(r);
        return;
      }
      if (pr(r)) {
        this.handlePending(r);
        return;
      }
    }
    this.handleStart();
  }
  detach() {
    this.listeners.removeAll(), this.windowListeners.removeAll(), setTimeout(this.documentListeners.removeAll, 50), this.timeoutId !== null && (clearTimeout(this.timeoutId), this.timeoutId = null);
  }
  handlePending(t, r) {
    const {
      active: n,
      onPending: o
    } = this.props;
    o(n, t, this.initialCoordinates, r);
  }
  handleStart() {
    const {
      initialCoordinates: t
    } = this, {
      onStart: r
    } = this.props;
    t && (this.activated = !0, this.documentListeners.add(Oe.Click, Gn, {
      capture: !0
    }), this.removeTextSelection(), this.documentListeners.add(Oe.SelectionChange, this.removeTextSelection), r(t));
  }
  handleMove(t) {
    var r;
    const {
      activated: n,
      initialCoordinates: o,
      props: s
    } = this, {
      onMove: i,
      options: {
        activationConstraint: a
      }
    } = s;
    if (!o)
      return;
    const d = (r = At(t)) != null ? r : Me, c = gt(o, d);
    if (!n && a) {
      if (pr(a)) {
        if (a.tolerance != null && Wt(c, a.tolerance))
          return this.handleCancel();
        if (Wt(c, a.distance))
          return this.handleStart();
      }
      if (hr(a) && Wt(c, a.tolerance))
        return this.handleCancel();
      this.handlePending(a, c);
      return;
    }
    t.cancelable && t.preventDefault(), i(d);
  }
  handleEnd() {
    const {
      onAbort: t,
      onEnd: r
    } = this.props;
    this.detach(), this.activated || t(this.props.active), r();
  }
  handleCancel() {
    const {
      onAbort: t,
      onCancel: r
    } = this.props;
    this.detach(), this.activated || t(this.props.active), r();
  }
  handleKeydown(t) {
    t.code === K.Esc && this.handleCancel();
  }
  removeTextSelection() {
    var t;
    (t = this.document.getSelection()) == null || t.removeAllRanges();
  }
}
const Jn = {
  cancel: {
    name: "pointercancel"
  },
  move: {
    name: "pointermove"
  },
  end: {
    name: "pointerup"
  }
};
class Ur extends tr {
  constructor(t) {
    const {
      event: r
    } = t, n = nt(r.target);
    super(t, Jn, n);
  }
}
Ur.activators = [{
  eventName: "onPointerDown",
  handler: (e, t) => {
    let {
      nativeEvent: r
    } = e, {
      onActivation: n
    } = t;
    return !r.isPrimary || r.button !== 0 ? !1 : (n?.({
      event: r
    }), !0);
  }
}];
const Zn = {
  move: {
    name: "mousemove"
  },
  end: {
    name: "mouseup"
  }
};
var Kt;
(function(e) {
  e[e.RightClick = 2] = "RightClick";
})(Kt || (Kt = {}));
class Br extends tr {
  constructor(t) {
    super(t, Zn, nt(t.event.target));
  }
}
Br.activators = [{
  eventName: "onMouseDown",
  handler: (e, t) => {
    let {
      nativeEvent: r
    } = e, {
      onActivation: n
    } = t;
    return r.button === Kt.RightClick ? !1 : (n?.({
      event: r
    }), !0);
  }
}];
const Ht = {
  cancel: {
    name: "touchcancel"
  },
  move: {
    name: "touchmove"
  },
  end: {
    name: "touchend"
  }
};
class Vr extends tr {
  constructor(t) {
    super(t, Ht);
  }
  static setup() {
    return window.addEventListener(Ht.move.name, t, {
      capture: !1,
      passive: !1
    }), function() {
      window.removeEventListener(Ht.move.name, t);
    };
    function t() {
    }
  }
}
Vr.activators = [{
  eventName: "onTouchStart",
  handler: (e, t) => {
    let {
      nativeEvent: r
    } = e, {
      onActivation: n
    } = t;
    const {
      touches: o
    } = r;
    return o.length > 1 ? !1 : (n?.({
      event: r
    }), !0);
  }
}];
var dt;
(function(e) {
  e[e.Pointer = 0] = "Pointer", e[e.DraggableRect = 1] = "DraggableRect";
})(dt || (dt = {}));
var It;
(function(e) {
  e[e.TreeOrder = 0] = "TreeOrder", e[e.ReversedTreeOrder = 1] = "ReversedTreeOrder";
})(It || (It = {}));
function eo(e) {
  let {
    acceleration: t,
    activator: r = dt.Pointer,
    canScroll: n,
    draggingRect: o,
    enabled: s,
    interval: i = 5,
    order: a = It.TreeOrder,
    pointerCoordinates: d,
    scrollableAncestors: c,
    scrollableAncestorRects: f,
    delta: u,
    threshold: p
  } = e;
  const m = ro({
    delta: u,
    disabled: !s
  }), [S, g] = hn(), b = J({
    x: 0,
    y: 0
  }), E = J({
    x: 0,
    y: 0
  }), _ = q(() => {
    switch (r) {
      case dt.Pointer:
        return d ? {
          top: d.y,
          bottom: d.y,
          left: d.x,
          right: d.x
        } : null;
      case dt.DraggableRect:
        return o;
    }
  }, [r, o, d]), D = J(null), N = te(() => {
    const A = D.current;
    if (!A)
      return;
    const k = b.current.x * E.current.x, M = b.current.y * E.current.y;
    A.scrollBy(k, M);
  }, []), T = q(() => a === It.TreeOrder ? [...c].reverse() : c, [a, c]);
  F(
    () => {
      if (!s || !c.length || !_) {
        g();
        return;
      }
      for (const A of T) {
        if (n?.(A) === !1)
          continue;
        const k = c.indexOf(A), M = f[k];
        if (!M)
          continue;
        const {
          direction: Z,
          speed: y
        } = Yn(A, M, _, t, p);
        for (const j of ["x", "y"])
          m[j][Z[j]] || (y[j] = 0, Z[j] = 0);
        if (y.x > 0 || y.y > 0) {
          g(), D.current = A, S(N, i), b.current = y, E.current = Z;
          return;
        }
      }
      b.current = {
        x: 0,
        y: 0
      }, E.current = {
        x: 0,
        y: 0
      }, g();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      t,
      N,
      n,
      g,
      s,
      i,
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(_),
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(m),
      S,
      c,
      T,
      f,
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(p)
    ]
  );
}
const to = {
  x: {
    [De.Backward]: !1,
    [De.Forward]: !1
  },
  y: {
    [De.Backward]: !1,
    [De.Forward]: !1
  }
};
function ro(e) {
  let {
    delta: t,
    disabled: r
  } = e;
  const n = Rt(t);
  return vt((o) => {
    if (r || !n || !o)
      return to;
    const s = {
      x: Math.sign(t.x - n.x),
      y: Math.sign(t.y - n.y)
    };
    return {
      x: {
        [De.Backward]: o.x[De.Backward] || s.x === -1,
        [De.Forward]: o.x[De.Forward] || s.x === 1
      },
      y: {
        [De.Backward]: o.y[De.Backward] || s.y === -1,
        [De.Forward]: o.y[De.Forward] || s.y === 1
      }
    };
  }, [r, t, n]);
}
function no(e, t) {
  const r = t != null ? e.get(t) : void 0, n = r ? r.node.current : null;
  return vt((o) => {
    var s;
    return t == null ? null : (s = n ?? o) != null ? s : null;
  }, [n, t]);
}
function oo(e, t) {
  return q(() => e.reduce((r, n) => {
    const {
      sensor: o
    } = n, s = o.activators.map((i) => ({
      eventName: i.eventName,
      handler: t(i.handler, n)
    }));
    return [...r, ...s];
  }, []), [e, t]);
}
var pt;
(function(e) {
  e[e.Always = 0] = "Always", e[e.BeforeDragging = 1] = "BeforeDragging", e[e.WhileDragging = 2] = "WhileDragging";
})(pt || (pt = {}));
var Gt;
(function(e) {
  e.Optimized = "optimized";
})(Gt || (Gt = {}));
const mr = /* @__PURE__ */ new Map();
function so(e, t) {
  let {
    dragging: r,
    dependencies: n,
    config: o
  } = t;
  const [s, i] = Y(null), {
    frequency: a,
    measure: d,
    strategy: c
  } = o, f = J(e), u = b(), p = ft(u), m = te(function(E) {
    E === void 0 && (E = []), !p.current && i((_) => _ === null ? E : _.concat(E.filter((D) => !_.includes(D))));
  }, [p]), S = J(null), g = vt((E) => {
    if (u && !r)
      return mr;
    if (!E || E === mr || f.current !== e || s != null) {
      const _ = /* @__PURE__ */ new Map();
      for (let D of e) {
        if (!D)
          continue;
        if (s && s.length > 0 && !s.includes(D.id) && D.rect.current) {
          _.set(D.id, D.rect.current);
          continue;
        }
        const N = D.node.current, T = N ? new Zt(d(N), N) : null;
        D.rect.current = T, T && _.set(D.id, T);
      }
      return _;
    }
    return E;
  }, [e, s, r, u, d]);
  return F(() => {
    f.current = e;
  }, [e]), F(
    () => {
      u || m();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [r, u]
  ), F(
    () => {
      s && s.length > 0 && i(null);
    },
    //eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(s)]
  ), F(
    () => {
      u || typeof a != "number" || S.current !== null || (S.current = setTimeout(() => {
        m(), S.current = null;
      }, a));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [a, u, m, ...n]
  ), {
    droppableRects: g,
    measureDroppableContainers: m,
    measuringScheduled: s != null
  };
  function b() {
    switch (c) {
      case pt.Always:
        return !1;
      case pt.BeforeDragging:
        return r;
      default:
        return !r;
    }
  }
}
function rr(e, t) {
  return vt((r) => e ? r || (typeof t == "function" ? t(e) : e) : null, [t, e]);
}
function ao(e, t) {
  return rr(e, t);
}
function io(e) {
  let {
    callback: t,
    disabled: r
  } = e;
  const n = Lt(t), o = q(() => {
    if (r || typeof window > "u" || typeof window.MutationObserver > "u")
      return;
    const {
      MutationObserver: s
    } = window;
    return new s(n);
  }, [n, r]);
  return F(() => () => o?.disconnect(), [o]), o;
}
function zt(e) {
  let {
    callback: t,
    disabled: r
  } = e;
  const n = Lt(t), o = q(
    () => {
      if (r || typeof window > "u" || typeof window.ResizeObserver > "u")
        return;
      const {
        ResizeObserver: s
      } = window;
      return new s(n);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [r]
  );
  return F(() => () => o?.disconnect(), [o]), o;
}
function lo(e) {
  return new Zt(ot(e), e);
}
function vr(e, t, r) {
  t === void 0 && (t = lo);
  const [n, o] = Y(null);
  function s() {
    o((d) => {
      if (!e)
        return null;
      if (e.isConnected === !1) {
        var c;
        return (c = d ?? r) != null ? c : null;
      }
      const f = t(e);
      return JSON.stringify(d) === JSON.stringify(f) ? d : f;
    });
  }
  const i = io({
    callback(d) {
      if (e)
        for (const c of d) {
          const {
            type: f,
            target: u
          } = c;
          if (f === "childList" && u instanceof HTMLElement && u.contains(e)) {
            s();
            break;
          }
        }
    }
  }), a = zt({
    callback: s
  });
  return ke(() => {
    s(), e ? (a?.observe(e), i?.observe(document.body, {
      childList: !0,
      subtree: !0
    })) : (a?.disconnect(), i?.disconnect());
  }, [e]), n;
}
function co(e) {
  const t = rr(e);
  return Ar(e, t);
}
const xr = [];
function uo(e) {
  const t = J(e), r = vt((n) => e ? n && n !== xr && e && t.current && e.parentNode === t.current.parentNode ? n : $t(e) : xr, [e]);
  return F(() => {
    t.current = e;
  }, [e]), r;
}
function fo(e) {
  const [t, r] = Y(null), n = J(e), o = te((s) => {
    const i = qt(s.target);
    i && r((a) => a ? (a.set(i, Xt(i)), new Map(a)) : null);
  }, []);
  return F(() => {
    const s = n.current;
    if (e !== s) {
      i(s);
      const a = e.map((d) => {
        const c = qt(d);
        return c ? (c.addEventListener("scroll", o, {
          passive: !0
        }), [c, Xt(c)]) : null;
      }).filter((d) => d != null);
      r(a.length ? new Map(a) : null), n.current = e;
    }
    return () => {
      i(e), i(s);
    };
    function i(a) {
      a.forEach((d) => {
        const c = qt(d);
        c?.removeEventListener("scroll", o);
      });
    }
  }, [o, e]), q(() => e.length ? t ? Array.from(t.values()).reduce((s, i) => tt(s, i), Me) : Pr(e) : Me, [e, t]);
}
function br(e, t) {
  t === void 0 && (t = []);
  const r = J(null);
  return F(
    () => {
      r.current = null;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  ), F(() => {
    const n = e !== Me;
    n && !r.current && (r.current = e), !n && r.current && (r.current = null);
  }, [e]), r.current ? gt(e, r.current) : Me;
}
function go(e) {
  F(
    () => {
      if (!Mt)
        return;
      const t = e.map((r) => {
        let {
          sensor: n
        } = r;
        return n.setup == null ? void 0 : n.setup();
      });
      return () => {
        for (const r of t)
          r?.();
      };
    },
    // TO-DO: Sensors length could theoretically change which would not be a valid dependency
    // eslint-disable-next-line react-hooks/exhaustive-deps
    e.map((t) => {
      let {
        sensor: r
      } = t;
      return r;
    })
  );
}
function po(e, t) {
  return q(() => e.reduce((r, n) => {
    let {
      eventName: o,
      handler: s
    } = n;
    return r[o] = (i) => {
      s(i, t);
    }, r;
  }, {}), [e, t]);
}
function Fr(e) {
  return q(() => e ? Un(e) : null, [e]);
}
const yr = [];
function ho(e, t) {
  t === void 0 && (t = ot);
  const [r] = e, n = Fr(r ? Re(r) : null), [o, s] = Y(yr);
  function i() {
    s(() => e.length ? e.map((d) => Mr(d) ? n : new Zt(t(d), d)) : yr);
  }
  const a = zt({
    callback: i
  });
  return ke(() => {
    a?.disconnect(), i(), e.forEach((d) => a?.observe(d));
  }, [e]), o;
}
function Yr(e) {
  if (!e)
    return null;
  if (e.children.length > 1)
    return e;
  const t = e.children[0];
  return mt(t) ? t : e;
}
function mo(e) {
  let {
    measure: t
  } = e;
  const [r, n] = Y(null), o = te((c) => {
    for (const {
      target: f
    } of c)
      if (mt(f)) {
        n((u) => {
          const p = t(f);
          return u ? {
            ...u,
            width: p.width,
            height: p.height
          } : p;
        });
        break;
      }
  }, [t]), s = zt({
    callback: o
  }), i = te((c) => {
    const f = Yr(c);
    s?.disconnect(), f && s?.observe(f), n(f ? t(f) : null);
  }, [t, s]), [a, d] = jt(i);
  return q(() => ({
    nodeRef: a,
    rect: r,
    setRef: d
  }), [r, a, d]);
}
const vo = [{
  sensor: Ur,
  options: {}
}, {
  sensor: er,
  options: {}
}], xo = {
  current: {}
}, St = {
  draggable: {
    measure: fr
  },
  droppable: {
    measure: fr,
    strategy: pt.WhileDragging,
    frequency: Gt.Optimized
  },
  dragOverlay: {
    measure: ot
  }
};
class ut extends Map {
  get(t) {
    var r;
    return t != null && (r = super.get(t)) != null ? r : void 0;
  }
  toArray() {
    return Array.from(this.values());
  }
  getEnabled() {
    return this.toArray().filter((t) => {
      let {
        disabled: r
      } = t;
      return !r;
    });
  }
  getNodeFor(t) {
    var r, n;
    return (r = (n = this.get(t)) == null ? void 0 : n.node.current) != null ? r : void 0;
  }
}
const bo = {
  activatorEvent: null,
  active: null,
  activeNode: null,
  activeNodeRect: null,
  collisions: null,
  containerNodeRect: null,
  draggableNodes: /* @__PURE__ */ new Map(),
  droppableRects: /* @__PURE__ */ new Map(),
  droppableContainers: /* @__PURE__ */ new ut(),
  over: null,
  dragOverlay: {
    nodeRef: {
      current: null
    },
    rect: null,
    setRef: Tt
  },
  scrollableAncestors: [],
  scrollableAncestorRects: [],
  measuringConfiguration: St,
  measureDroppableContainers: Tt,
  windowRect: null,
  measuringScheduled: !1
}, qr = {
  activatorEvent: null,
  activators: [],
  active: null,
  activeNodeRect: null,
  ariaDescribedById: {
    draggable: ""
  },
  dispatch: Tt,
  draggableNodes: /* @__PURE__ */ new Map(),
  over: null,
  measureDroppableContainers: Tt
}, bt = /* @__PURE__ */ ht(qr), Wr = /* @__PURE__ */ ht(bo);
function yo() {
  return {
    draggable: {
      active: null,
      initialCoordinates: {
        x: 0,
        y: 0
      },
      nodes: /* @__PURE__ */ new Map(),
      translate: {
        x: 0,
        y: 0
      }
    },
    droppable: {
      containers: new ut()
    }
  };
}
function wo(e, t) {
  switch (t.type) {
    case ye.DragStart:
      return {
        ...e,
        draggable: {
          ...e.draggable,
          initialCoordinates: t.initialCoordinates,
          active: t.active
        }
      };
    case ye.DragMove:
      return e.draggable.active == null ? e : {
        ...e,
        draggable: {
          ...e.draggable,
          translate: {
            x: t.coordinates.x - e.draggable.initialCoordinates.x,
            y: t.coordinates.y - e.draggable.initialCoordinates.y
          }
        }
      };
    case ye.DragEnd:
    case ye.DragCancel:
      return {
        ...e,
        draggable: {
          ...e.draggable,
          active: null,
          initialCoordinates: {
            x: 0,
            y: 0
          },
          translate: {
            x: 0,
            y: 0
          }
        }
      };
    case ye.RegisterDroppable: {
      const {
        element: r
      } = t, {
        id: n
      } = r, o = new ut(e.droppable.containers);
      return o.set(n, r), {
        ...e,
        droppable: {
          ...e.droppable,
          containers: o
        }
      };
    }
    case ye.SetDroppableDisabled: {
      const {
        id: r,
        key: n,
        disabled: o
      } = t, s = e.droppable.containers.get(r);
      if (!s || n !== s.key)
        return e;
      const i = new ut(e.droppable.containers);
      return i.set(r, {
        ...s,
        disabled: o
      }), {
        ...e,
        droppable: {
          ...e.droppable,
          containers: i
        }
      };
    }
    case ye.UnregisterDroppable: {
      const {
        id: r,
        key: n
      } = t, o = e.droppable.containers.get(r);
      if (!o || n !== o.key)
        return e;
      const s = new ut(e.droppable.containers);
      return s.delete(r), {
        ...e,
        droppable: {
          ...e.droppable,
          containers: s
        }
      };
    }
    default:
      return e;
  }
}
function Do(e) {
  let {
    disabled: t
  } = e;
  const {
    active: r,
    activatorEvent: n,
    draggableNodes: o
  } = qe(bt), s = Rt(n), i = Rt(r?.id);
  return F(() => {
    if (!t && !n && s && i != null) {
      if (!Pt(s) || document.activeElement === s.target)
        return;
      const a = o.get(i);
      if (!a)
        return;
      const {
        activatorNode: d,
        node: c
      } = a;
      if (!d.current && !c.current)
        return;
      requestAnimationFrame(() => {
        for (const f of [d.current, c.current]) {
          if (!f)
            continue;
          const u = xn(f);
          if (u) {
            u.focus();
            break;
          }
        }
      });
    }
  }, [n, t, o, i, s]), null;
}
function Hr(e, t) {
  let {
    transform: r,
    ...n
  } = t;
  return e != null && e.length ? e.reduce((o, s) => s({
    transform: o,
    ...n
  }), r) : r;
}
function _o(e) {
  return q(
    () => ({
      draggable: {
        ...St.draggable,
        ...e?.draggable
      },
      droppable: {
        ...St.droppable,
        ...e?.droppable
      },
      dragOverlay: {
        ...St.dragOverlay,
        ...e?.dragOverlay
      }
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e?.draggable, e?.droppable, e?.dragOverlay]
  );
}
function Co(e) {
  let {
    activeNode: t,
    measure: r,
    initialRect: n,
    config: o = !0
  } = e;
  const s = J(!1), {
    x: i,
    y: a
  } = typeof o == "boolean" ? {
    x: o,
    y: o
  } : o;
  ke(() => {
    if (!i && !a || !t) {
      s.current = !1;
      return;
    }
    if (s.current || !n)
      return;
    const c = t?.node.current;
    if (!c || c.isConnected === !1)
      return;
    const f = r(c), u = Ar(f, n);
    if (i || (u.x = 0), a || (u.y = 0), s.current = !0, Math.abs(u.x) > 0 || Math.abs(u.y) > 0) {
      const p = Ir(c);
      p && p.scrollBy({
        top: u.y,
        left: u.x
      });
    }
  }, [t, i, a, n, r]);
}
const Ut = /* @__PURE__ */ ht({
  ...Me,
  scaleX: 1,
  scaleY: 1
});
var Ye;
(function(e) {
  e[e.Uninitialized = 0] = "Uninitialized", e[e.Initializing = 1] = "Initializing", e[e.Initialized = 2] = "Initialized";
})(Ye || (Ye = {}));
const No = /* @__PURE__ */ an(function(t) {
  var r, n, o, s;
  let {
    id: i,
    accessibility: a,
    autoScroll: d = !0,
    children: c,
    sensors: f = vo,
    collisionDetection: u = Rr,
    measuring: p,
    modifiers: m,
    ...S
  } = t;
  const g = Cr(wo, void 0, yo), [b, E] = g, [_, D] = Cn(), [N, T] = Y(Ye.Uninitialized), A = N === Ye.Initialized, {
    draggable: {
      active: k,
      nodes: M,
      translate: Z
    },
    droppable: {
      containers: y
    }
  } = b, j = k != null ? M.get(k) : null, G = J({
    initial: null,
    translated: null
  }), oe = q(() => {
    var H;
    return k != null ? {
      id: k,
      // It's possible for the active node to unmount while dragging
      data: (H = j?.data) != null ? H : xo,
      rect: G
    } : null;
  }, [k, j]), ne = J(null), [me, we] = Y(null), [se, Ee] = Y(null), le = ft(S, Object.values(S)), h = xt("DndDescribedBy", i), P = q(() => y.getEnabled(), [y]), B = _o(p), {
    droppableRects: ee,
    measureDroppableContainers: C,
    measuringScheduled: z
  } = so(P, {
    dragging: A,
    dependencies: [Z.x, Z.y],
    config: B.droppable
  }), ce = no(M, k), ve = q(() => se ? At(se) : null, [se]), U = V(), W = ao(ce, B.draggable.measure);
  Co({
    activeNode: k != null ? M.get(k) : null,
    config: U.layoutShiftCompensation,
    initialRect: W,
    measure: B.draggable.measure
  });
  const $ = vr(ce, B.draggable.measure, W), Ae = vr(ce ? ce.parentElement : null), ge = J({
    activatorEvent: null,
    active: null,
    activeNode: ce,
    collisionRect: null,
    collisions: null,
    droppableRects: ee,
    draggableNodes: M,
    draggingNode: null,
    draggingNodeRect: null,
    droppableContainers: y,
    over: null,
    scrollableAncestors: [],
    scrollAdjustedTranslate: null
  }), Ie = y.getNodeFor((r = ge.current.over) == null ? void 0 : r.id), Se = mo({
    measure: B.dragOverlay.measure
  }), Le = (n = Se.nodeRef.current) != null ? n : ce, $e = A ? (o = Se.rect) != null ? o : $ : null, Ge = !!(Se.nodeRef.current && Se.rect), yt = co(Ge ? null : $), He = Fr(Le ? Re(Le) : null), Pe = uo(A ? Ie ?? ce : null), Qe = ho(Pe), Je = Hr(m, {
    transform: {
      x: Z.x - yt.x,
      y: Z.y - yt.y,
      scaleX: 1,
      scaleY: 1
    },
    activatorEvent: se,
    active: oe,
    activeNodeRect: $,
    containerNodeRect: Ae,
    draggingNodeRect: $e,
    over: ge.current.over,
    overlayNodeRect: Se.rect,
    scrollableAncestors: Pe,
    scrollableAncestorRects: Qe,
    windowRect: He
  }), wt = ve ? tt(ve, Z) : null, Dt = fo(Pe), Bt = br(Dt), Vt = br(Dt, [$]), ze = tt(Je, Bt), Xe = $e ? Pn($e, Je) : null, Ze = oe && Xe ? u({
    active: oe,
    collisionRect: Xe,
    droppableRects: ee,
    droppableContainers: P,
    pointerCoordinates: wt
  }) : null, Ue = jr(Ze, "id"), [v, w] = Y(null), x = Ge ? Je : tt(Je, Vt), I = Mn(x, (s = v?.rect) != null ? s : null, $), X = J(null), O = te(
    (H, fe) => {
      let {
        sensor: pe,
        options: xe
      } = fe;
      if (ne.current == null)
        return;
      const be = M.get(ne.current);
      if (!be)
        return;
      const ae = H.nativeEvent, de = new pe({
        active: ne.current,
        activeNode: be,
        event: ae,
        options: xe,
        // Sensors need to be instantiated with refs for arguments that change over time
        // otherwise they are frozen in time with the stale arguments
        context: ge,
        onAbort(ie) {
          if (!M.get(ie))
            return;
          const {
            onDragAbort: Ce
          } = le.current, Ne = {
            id: ie
          };
          Ce?.(Ne), _({
            type: "onDragAbort",
            event: Ne
          });
        },
        onPending(ie, _e, Ce, Ne) {
          if (!M.get(ie))
            return;
          const {
            onDragPending: Te
          } = le.current, Be = {
            id: ie,
            constraint: _e,
            initialCoordinates: Ce,
            offset: Ne
          };
          Te?.(Be), _({
            type: "onDragPending",
            event: Be
          });
        },
        onStart(ie) {
          const _e = ne.current;
          if (_e == null)
            return;
          const Ce = M.get(_e);
          if (!Ce)
            return;
          const {
            onDragStart: Ne
          } = le.current, je = {
            activatorEvent: ae,
            active: {
              id: _e,
              data: Ce.data,
              rect: G
            }
          };
          _t(() => {
            Ne?.(je), T(Ye.Initializing), E({
              type: ye.DragStart,
              initialCoordinates: ie,
              active: _e
            }), _({
              type: "onDragStart",
              event: je
            }), we(X.current), Ee(ae);
          });
        },
        onMove(ie) {
          E({
            type: ye.DragMove,
            coordinates: ie
          });
        },
        onEnd: he(ye.DragEnd),
        onCancel: he(ye.DragCancel)
      });
      X.current = de;
      function he(ie) {
        return async function() {
          const {
            active: Ce,
            collisions: Ne,
            over: je,
            scrollAdjustedTranslate: Te
          } = ge.current;
          let Be = null;
          if (Ce && Te) {
            const {
              cancelDrop: Fe
            } = le.current;
            Be = {
              activatorEvent: ae,
              active: Ce,
              collisions: Ne,
              delta: Te,
              over: je
            }, ie === ye.DragEnd && typeof Fe == "function" && await Promise.resolve(Fe(Be)) && (ie = ye.DragCancel);
          }
          ne.current = null, _t(() => {
            E({
              type: ie
            }), T(Ye.Uninitialized), w(null), we(null), Ee(null), X.current = null;
            const Fe = ie === ye.DragEnd ? "onDragEnd" : "onDragCancel";
            if (Be) {
              const et = le.current[Fe];
              et?.(Be), _({
                type: Fe,
                event: Be
              });
            }
          });
        };
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [M]
  ), Q = te((H, fe) => (pe, xe) => {
    const be = pe.nativeEvent, ae = M.get(xe);
    if (
      // Another sensor is already instantiating
      ne.current !== null || // No active draggable
      !ae || // Event has already been captured
      be.dndKit || be.defaultPrevented
    )
      return;
    const de = {
      active: ae
    };
    H(pe, fe.options, de) === !0 && (be.dndKit = {
      capturedBy: fe.sensor
    }, ne.current = xe, O(pe, fe));
  }, [M, O]), R = oo(f, Q);
  go(f), ke(() => {
    $ && N === Ye.Initializing && T(Ye.Initialized);
  }, [$, N]), F(
    () => {
      const {
        onDragMove: H
      } = le.current, {
        active: fe,
        activatorEvent: pe,
        collisions: xe,
        over: be
      } = ge.current;
      if (!fe || !pe)
        return;
      const ae = {
        active: fe,
        activatorEvent: pe,
        collisions: xe,
        delta: {
          x: ze.x,
          y: ze.y
        },
        over: be
      };
      _t(() => {
        H?.(ae), _({
          type: "onDragMove",
          event: ae
        });
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ze.x, ze.y]
  ), F(
    () => {
      const {
        active: H,
        activatorEvent: fe,
        collisions: pe,
        droppableContainers: xe,
        scrollAdjustedTranslate: be
      } = ge.current;
      if (!H || ne.current == null || !fe || !be)
        return;
      const {
        onDragOver: ae
      } = le.current, de = xe.get(Ue), he = de && de.rect.current ? {
        id: de.id,
        rect: de.rect.current,
        data: de.data,
        disabled: de.disabled
      } : null, ie = {
        active: H,
        activatorEvent: fe,
        collisions: pe,
        delta: {
          x: be.x,
          y: be.y
        },
        over: he
      };
      _t(() => {
        w(he), ae?.(ie), _({
          type: "onDragOver",
          event: ie
        });
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [Ue]
  ), ke(() => {
    ge.current = {
      activatorEvent: se,
      active: oe,
      activeNode: ce,
      collisionRect: Xe,
      collisions: Ze,
      droppableRects: ee,
      draggableNodes: M,
      draggingNode: Le,
      draggingNodeRect: $e,
      droppableContainers: y,
      over: v,
      scrollableAncestors: Pe,
      scrollAdjustedTranslate: ze
    }, G.current = {
      initial: $e,
      translated: Xe
    };
  }, [oe, ce, Ze, Xe, M, Le, $e, ee, y, v, Pe, ze]), eo({
    ...U,
    delta: Z,
    draggingRect: Xe,
    pointerCoordinates: wt,
    scrollableAncestors: Pe,
    scrollableAncestorRects: Qe
  });
  const L = q(() => ({
    active: oe,
    activeNode: ce,
    activeNodeRect: $,
    activatorEvent: se,
    collisions: Ze,
    containerNodeRect: Ae,
    dragOverlay: Se,
    draggableNodes: M,
    droppableContainers: y,
    droppableRects: ee,
    over: v,
    measureDroppableContainers: C,
    scrollableAncestors: Pe,
    scrollableAncestorRects: Qe,
    measuringConfiguration: B,
    measuringScheduled: z,
    windowRect: He
  }), [oe, ce, $, se, Ze, Ae, Se, M, y, ee, v, C, Pe, Qe, B, z, He]), re = q(() => ({
    activatorEvent: se,
    activators: R,
    active: oe,
    activeNodeRect: $,
    ariaDescribedById: {
      draggable: h
    },
    dispatch: E,
    draggableNodes: M,
    over: v,
    measureDroppableContainers: C
  }), [se, R, oe, $, E, h, M, v, C]);
  return ue.createElement(Sr.Provider, {
    value: D
  }, ue.createElement(bt.Provider, {
    value: re
  }, ue.createElement(Wr.Provider, {
    value: L
  }, ue.createElement(Ut.Provider, {
    value: I
  }, c)), ue.createElement(Do, {
    disabled: a?.restoreFocus === !1
  })), ue.createElement(Sn, {
    ...a,
    hiddenTextDescribedById: h
  }));
  function V() {
    const H = me?.autoScrollEnabled === !1, fe = typeof d == "object" ? d.enabled === !1 : d === !1, pe = A && !H && !fe;
    return typeof d == "object" ? {
      ...d,
      enabled: pe
    } : {
      enabled: pe
    };
  }
}), Eo = /* @__PURE__ */ ht(null), wr = "button", So = "Draggable";
function jo(e) {
  let {
    id: t,
    data: r,
    disabled: n = !1,
    attributes: o
  } = e;
  const s = xt(So), {
    activators: i,
    activatorEvent: a,
    active: d,
    activeNodeRect: c,
    ariaDescribedById: f,
    draggableNodes: u,
    over: p
  } = qe(bt), {
    role: m = wr,
    roleDescription: S = "draggable",
    tabIndex: g = 0
  } = o ?? {}, b = d?.id === t, E = qe(b ? Ut : Eo), [_, D] = jt(), [N, T] = jt(), A = po(i, t), k = ft(r);
  ke(
    () => (u.set(t, {
      id: t,
      key: s,
      node: _,
      activatorNode: N,
      data: k
    }), () => {
      const Z = u.get(t);
      Z && Z.key === s && u.delete(t);
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [u, t]
  );
  const M = q(() => ({
    role: m,
    tabIndex: g,
    "aria-disabled": n,
    "aria-pressed": b && m === wr ? !0 : void 0,
    "aria-roledescription": S,
    "aria-describedby": f.draggable
  }), [n, m, g, b, S, f.draggable]);
  return {
    active: d,
    activatorEvent: a,
    activeNodeRect: c,
    attributes: M,
    isDragging: b,
    listeners: n ? void 0 : A,
    node: _,
    over: p,
    setNodeRef: D,
    setActivatorNodeRef: T,
    transform: E
  };
}
function Xr() {
  return qe(Wr);
}
const Ro = "Droppable", Ao = {
  timeout: 25
};
function Kr(e) {
  let {
    data: t,
    disabled: r = !1,
    id: n,
    resizeObserverConfig: o
  } = e;
  const s = xt(Ro), {
    active: i,
    dispatch: a,
    over: d,
    measureDroppableContainers: c
  } = qe(bt), f = J({
    disabled: r
  }), u = J(!1), p = J(null), m = J(null), {
    disabled: S,
    updateMeasurementsFor: g,
    timeout: b
  } = {
    ...Ao,
    ...o
  }, E = ft(g ?? n), _ = te(
    () => {
      if (!u.current) {
        u.current = !0;
        return;
      }
      m.current != null && clearTimeout(m.current), m.current = setTimeout(() => {
        c(Array.isArray(E.current) ? E.current : [E.current]), m.current = null;
      }, b);
    },
    //eslint-disable-next-line react-hooks/exhaustive-deps
    [b]
  ), D = zt({
    callback: _,
    disabled: S || !i
  }), N = te((M, Z) => {
    D && (Z && (D.unobserve(Z), u.current = !1), M && D.observe(M));
  }, [D]), [T, A] = jt(N), k = ft(t);
  return F(() => {
    !D || !T.current || (D.disconnect(), u.current = !1, D.observe(T.current));
  }, [T, D]), F(
    () => (a({
      type: ye.RegisterDroppable,
      element: {
        id: n,
        key: s,
        disabled: r,
        node: T,
        rect: p,
        data: k
      }
    }), () => a({
      type: ye.UnregisterDroppable,
      key: s,
      id: n
    })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [n]
  ), F(() => {
    r !== f.current.disabled && (a({
      type: ye.SetDroppableDisabled,
      id: n,
      key: s,
      disabled: r
    }), f.current.disabled = r);
  }, [n, s, r, a]), {
    active: i,
    rect: p,
    isOver: d?.id === n,
    node: T,
    over: d,
    setNodeRef: A
  };
}
function To(e) {
  let {
    animation: t,
    children: r
  } = e;
  const [n, o] = Y(null), [s, i] = Y(null), a = Rt(r);
  return !r && !n && a && o(a), ke(() => {
    if (!s)
      return;
    const d = n?.key, c = n?.props.id;
    if (d == null || c == null) {
      o(null);
      return;
    }
    Promise.resolve(t(c, s)).then(() => {
      o(null);
    });
  }, [t, n, s]), ue.createElement(ue.Fragment, null, r, n ? cn(n, {
    ref: i
  }) : null);
}
const Io = {
  x: 0,
  y: 0,
  scaleX: 1,
  scaleY: 1
};
function Oo(e) {
  let {
    children: t
  } = e;
  return ue.createElement(bt.Provider, {
    value: qr
  }, ue.createElement(Ut.Provider, {
    value: Io
  }, t));
}
const ko = {
  position: "fixed",
  touchAction: "none"
}, Mo = (e) => Pt(e) ? "transform 250ms ease" : void 0, Lo = /* @__PURE__ */ ln((e, t) => {
  let {
    as: r,
    activatorEvent: n,
    adjustScale: o,
    children: s,
    className: i,
    rect: a,
    style: d,
    transform: c,
    transition: f = Mo
  } = e;
  if (!a)
    return null;
  const u = o ? c : {
    ...c,
    scaleX: 1,
    scaleY: 1
  }, p = {
    ...ko,
    width: a.width,
    height: a.height,
    top: a.top,
    left: a.left,
    transform: We.Transform.toString(u),
    transformOrigin: o && n ? An(n, a) : void 0,
    transition: typeof f == "function" ? f(n) : f,
    ...d
  };
  return ue.createElement(r, {
    className: i,
    style: p,
    ref: t
  }, s);
}), Po = (e) => (t) => {
  let {
    active: r,
    dragOverlay: n
  } = t;
  const o = {}, {
    styles: s,
    className: i
  } = e;
  if (s != null && s.active)
    for (const [a, d] of Object.entries(s.active))
      d !== void 0 && (o[a] = r.node.style.getPropertyValue(a), r.node.style.setProperty(a, d));
  if (s != null && s.dragOverlay)
    for (const [a, d] of Object.entries(s.dragOverlay))
      d !== void 0 && n.node.style.setProperty(a, d);
  return i != null && i.active && r.node.classList.add(i.active), i != null && i.dragOverlay && n.node.classList.add(i.dragOverlay), function() {
    for (const [d, c] of Object.entries(o))
      r.node.style.setProperty(d, c);
    i != null && i.active && r.node.classList.remove(i.active);
  };
}, $o = (e) => {
  let {
    transform: {
      initial: t,
      final: r
    }
  } = e;
  return [{
    transform: We.Transform.toString(t)
  }, {
    transform: We.Transform.toString(r)
  }];
}, zo = {
  duration: 250,
  easing: "ease",
  keyframes: $o,
  sideEffects: /* @__PURE__ */ Po({
    styles: {
      active: {
        opacity: "0"
      }
    }
  })
};
function Uo(e) {
  let {
    config: t,
    draggableNodes: r,
    droppableContainers: n,
    measuringConfiguration: o
  } = e;
  return Lt((s, i) => {
    if (t === null)
      return;
    const a = r.get(s);
    if (!a)
      return;
    const d = a.node.current;
    if (!d)
      return;
    const c = Yr(i);
    if (!c)
      return;
    const {
      transform: f
    } = Re(i).getComputedStyle(i), u = Tr(f);
    if (!u)
      return;
    const p = typeof t == "function" ? t : Bo(t);
    return $r(d, o.draggable.measure), p({
      active: {
        id: s,
        data: a.data,
        node: d,
        rect: o.draggable.measure(d)
      },
      draggableNodes: r,
      dragOverlay: {
        node: i,
        rect: o.dragOverlay.measure(c)
      },
      droppableContainers: n,
      measuringConfiguration: o,
      transform: u
    });
  });
}
function Bo(e) {
  const {
    duration: t,
    easing: r,
    sideEffects: n,
    keyframes: o
  } = {
    ...zo,
    ...e
  };
  return (s) => {
    let {
      active: i,
      dragOverlay: a,
      transform: d,
      ...c
    } = s;
    if (!t)
      return;
    const f = {
      x: a.rect.left - i.rect.left,
      y: a.rect.top - i.rect.top
    }, u = {
      scaleX: d.scaleX !== 1 ? i.rect.width * d.scaleX / a.rect.width : 1,
      scaleY: d.scaleY !== 1 ? i.rect.height * d.scaleY / a.rect.height : 1
    }, p = {
      x: d.x - f.x,
      y: d.y - f.y,
      ...u
    }, m = o({
      ...c,
      active: i,
      dragOverlay: a,
      transform: {
        initial: d,
        final: p
      }
    }), [S] = m, g = m[m.length - 1];
    if (JSON.stringify(S) === JSON.stringify(g))
      return;
    const b = n?.({
      active: i,
      dragOverlay: a,
      ...c
    }), E = a.node.animate(m, {
      duration: t,
      easing: r,
      fill: "forwards"
    });
    return new Promise((_) => {
      E.onfinish = () => {
        b?.(), _();
      };
    });
  };
}
let Dr = 0;
function Vo(e) {
  return q(() => {
    if (e != null)
      return Dr++, Dr;
  }, [e]);
}
const Fo = /* @__PURE__ */ ue.memo((e) => {
  let {
    adjustScale: t = !1,
    children: r,
    dropAnimation: n,
    style: o,
    transition: s,
    modifiers: i,
    wrapperElement: a = "div",
    className: d,
    zIndex: c = 999
  } = e;
  const {
    activatorEvent: f,
    active: u,
    activeNodeRect: p,
    containerNodeRect: m,
    draggableNodes: S,
    droppableContainers: g,
    dragOverlay: b,
    over: E,
    measuringConfiguration: _,
    scrollableAncestors: D,
    scrollableAncestorRects: N,
    windowRect: T
  } = Xr(), A = qe(Ut), k = Vo(u?.id), M = Hr(i, {
    activatorEvent: f,
    active: u,
    activeNodeRect: p,
    containerNodeRect: m,
    draggingNodeRect: b.rect,
    over: E,
    overlayNodeRect: b.rect,
    scrollableAncestors: D,
    scrollableAncestorRects: N,
    transform: A,
    windowRect: T
  }), Z = rr(p), y = Uo({
    config: n,
    draggableNodes: S,
    droppableContainers: g,
    measuringConfiguration: _
  }), j = Z ? b.setRef : void 0;
  return ue.createElement(Oo, null, ue.createElement(To, {
    animation: y
  }, u && k ? ue.createElement(Lo, {
    key: k,
    id: u.id,
    ref: j,
    as: a,
    activatorEvent: f,
    adjustScale: t,
    className: d,
    transition: s,
    rect: Z,
    style: {
      zIndex: c,
      ...o
    },
    transform: M
  }, r) : null));
});
function nr(e, t, r) {
  const n = e.slice();
  return n.splice(r < 0 ? n.length + r : r, 0, n.splice(t, 1)[0]), n;
}
function Yo(e, t) {
  return e.reduce((r, n, o) => {
    const s = t.get(n);
    return s && (r[o] = s), r;
  }, Array(e.length));
}
function Nt(e) {
  return e !== null && e >= 0;
}
function qo(e, t) {
  if (e === t)
    return !0;
  if (e.length !== t.length)
    return !1;
  for (let r = 0; r < e.length; r++)
    if (e[r] !== t[r])
      return !1;
  return !0;
}
function Wo(e) {
  return typeof e == "boolean" ? {
    draggable: e,
    droppable: e
  } : e;
}
const Gr = (e) => {
  let {
    rects: t,
    activeIndex: r,
    overIndex: n,
    index: o
  } = e;
  const s = nr(t, n, r), i = t[o], a = s[o];
  return !a || !i ? null : {
    x: a.left - i.left,
    y: a.top - i.top,
    scaleX: a.width / i.width,
    scaleY: a.height / i.height
  };
}, Et = {
  scaleX: 1,
  scaleY: 1
}, Ho = (e) => {
  var t;
  let {
    activeIndex: r,
    activeNodeRect: n,
    index: o,
    rects: s,
    overIndex: i
  } = e;
  const a = (t = s[r]) != null ? t : n;
  if (!a)
    return null;
  if (o === r) {
    const c = s[i];
    return c ? {
      x: 0,
      y: r < i ? c.top + c.height - (a.top + a.height) : c.top - a.top,
      ...Et
    } : null;
  }
  const d = Xo(s, o, r);
  return o > r && o <= i ? {
    x: 0,
    y: -a.height - d,
    ...Et
  } : o < r && o >= i ? {
    x: 0,
    y: a.height + d,
    ...Et
  } : {
    x: 0,
    y: 0,
    ...Et
  };
};
function Xo(e, t, r) {
  const n = e[t], o = e[t - 1], s = e[t + 1];
  return n ? r < t ? o ? n.top - (o.top + o.height) : s ? s.top - (n.top + n.height) : 0 : s ? s.top - (n.top + n.height) : o ? n.top - (o.top + o.height) : 0 : 0;
}
const Qr = "Sortable", Jr = /* @__PURE__ */ ue.createContext({
  activeIndex: -1,
  containerId: Qr,
  disableTransforms: !1,
  items: [],
  overIndex: -1,
  useDragOverlay: !1,
  sortedRects: [],
  strategy: Gr,
  disabled: {
    draggable: !1,
    droppable: !1
  }
});
function Ko(e) {
  let {
    children: t,
    id: r,
    items: n,
    strategy: o = Gr,
    disabled: s = !1
  } = e;
  const {
    active: i,
    dragOverlay: a,
    droppableRects: d,
    over: c,
    measureDroppableContainers: f
  } = Xr(), u = xt(Qr, r), p = a.rect !== null, m = q(() => n.map((A) => typeof A == "object" && "id" in A ? A.id : A), [n]), S = i != null, g = i ? m.indexOf(i.id) : -1, b = c ? m.indexOf(c.id) : -1, E = J(m), _ = !qo(m, E.current), D = b !== -1 && g === -1 || _, N = Wo(s);
  ke(() => {
    _ && S && f(m);
  }, [_, m, S, f]), F(() => {
    E.current = m;
  }, [m]);
  const T = q(
    () => ({
      activeIndex: g,
      containerId: u,
      disabled: N,
      disableTransforms: D,
      items: m,
      overIndex: b,
      useDragOverlay: p,
      sortedRects: Yo(m, d),
      strategy: o
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [g, u, N.draggable, N.droppable, D, m, b, d, p, o]
  );
  return ue.createElement(Jr.Provider, {
    value: T
  }, t);
}
const Go = (e) => {
  let {
    id: t,
    items: r,
    activeIndex: n,
    overIndex: o
  } = e;
  return nr(r, n, o).indexOf(t);
}, Qo = (e) => {
  let {
    containerId: t,
    isSorting: r,
    wasDragging: n,
    index: o,
    items: s,
    newIndex: i,
    previousItems: a,
    previousContainerId: d,
    transition: c
  } = e;
  return !c || !n || a !== s && o === i ? !1 : r ? !0 : i !== o && t === d;
}, Jo = {
  duration: 200,
  easing: "ease"
}, Zr = "transform", Zo = /* @__PURE__ */ We.Transition.toString({
  property: Zr,
  duration: 0,
  easing: "linear"
}), es = {
  roleDescription: "sortable"
};
function ts(e) {
  let {
    disabled: t,
    index: r,
    node: n,
    rect: o
  } = e;
  const [s, i] = Y(null), a = J(r);
  return ke(() => {
    if (!t && r !== a.current && n.current) {
      const d = o.current;
      if (d) {
        const c = ot(n.current, {
          ignoreTransform: !0
        }), f = {
          x: d.left - c.left,
          y: d.top - c.top,
          scaleX: d.width / c.width,
          scaleY: d.height / c.height
        };
        (f.x || f.y) && i(f);
      }
    }
    r !== a.current && (a.current = r);
  }, [t, r, n, o]), F(() => {
    s && i(null);
  }, [s]), s;
}
function rs(e) {
  let {
    animateLayoutChanges: t = Qo,
    attributes: r,
    disabled: n,
    data: o,
    getNewIndex: s = Go,
    id: i,
    strategy: a,
    resizeObserverConfig: d,
    transition: c = Jo
  } = e;
  const {
    items: f,
    containerId: u,
    activeIndex: p,
    disabled: m,
    disableTransforms: S,
    sortedRects: g,
    overIndex: b,
    useDragOverlay: E,
    strategy: _
  } = qe(Jr), D = ns(n, m), N = f.indexOf(i), T = q(() => ({
    sortable: {
      containerId: u,
      index: N,
      items: f
    },
    ...o
  }), [u, o, N, f]), A = q(() => f.slice(f.indexOf(i)), [f, i]), {
    rect: k,
    node: M,
    isOver: Z,
    setNodeRef: y
  } = Kr({
    id: i,
    data: T,
    disabled: D.droppable,
    resizeObserverConfig: {
      updateMeasurementsFor: A,
      ...d
    }
  }), {
    active: j,
    activatorEvent: G,
    activeNodeRect: oe,
    attributes: ne,
    setNodeRef: me,
    listeners: we,
    isDragging: se,
    over: Ee,
    setActivatorNodeRef: le,
    transform: h
  } = jo({
    id: i,
    data: T,
    attributes: {
      ...es,
      ...r
    },
    disabled: D.draggable
  }), P = pn(y, me), B = !!j, ee = B && !S && Nt(p) && Nt(b), C = !E && se, z = C && ee ? h : null, ve = ee ? z ?? (a ?? _)({
    rects: g,
    activeNodeRect: oe,
    activeIndex: p,
    overIndex: b,
    index: N
  }) : null, U = Nt(p) && Nt(b) ? s({
    id: i,
    items: f,
    activeIndex: p,
    overIndex: b
  }) : N, W = j?.id, $ = J({
    activeId: W,
    items: f,
    newIndex: U,
    containerId: u
  }), Ae = f !== $.current.items, ge = t({
    active: j,
    containerId: u,
    isDragging: se,
    isSorting: B,
    id: i,
    index: N,
    items: f,
    newIndex: $.current.newIndex,
    previousItems: $.current.items,
    previousContainerId: $.current.containerId,
    transition: c,
    wasDragging: $.current.activeId != null
  }), Ie = ts({
    disabled: !ge,
    index: N,
    node: M,
    rect: k
  });
  return F(() => {
    B && $.current.newIndex !== U && ($.current.newIndex = U), u !== $.current.containerId && ($.current.containerId = u), f !== $.current.items && ($.current.items = f);
  }, [B, U, u, f]), F(() => {
    if (W === $.current.activeId)
      return;
    if (W != null && $.current.activeId == null) {
      $.current.activeId = W;
      return;
    }
    const Le = setTimeout(() => {
      $.current.activeId = W;
    }, 50);
    return () => clearTimeout(Le);
  }, [W]), {
    active: j,
    activeIndex: p,
    attributes: ne,
    data: T,
    rect: k,
    index: N,
    newIndex: U,
    items: f,
    isOver: Z,
    isSorting: B,
    isDragging: se,
    listeners: we,
    node: M,
    overIndex: b,
    over: Ee,
    setNodeRef: P,
    setActivatorNodeRef: le,
    setDroppableNodeRef: y,
    setDraggableNodeRef: me,
    transform: Ie ?? ve,
    transition: Se()
  };
  function Se() {
    if (
      // Temporarily disable transitions for a single frame to set up derived transforms
      Ie || // Or to prevent items jumping to back to their "new" position when items change
      Ae && $.current.newIndex === N
    )
      return Zo;
    if (!(C && !Pt(G) || !c) && (B || ge))
      return We.Transition.toString({
        ...c,
        property: Zr
      });
  }
}
function ns(e, t) {
  var r, n;
  return typeof e == "boolean" ? {
    draggable: e,
    // Backwards compatibility
    droppable: !1
  } : {
    draggable: (r = e?.draggable) != null ? r : t.draggable,
    droppable: (n = e?.droppable) != null ? n : t.droppable
  };
}
function Ot(e) {
  if (!e)
    return !1;
  const t = e.data.current;
  return !!(t && "sortable" in t && typeof t.sortable == "object" && "containerId" in t.sortable && "items" in t.sortable && "index" in t.sortable);
}
const os = [K.Down, K.Right, K.Up, K.Left], ss = (e, t) => {
  let {
    context: {
      active: r,
      collisionRect: n,
      droppableRects: o,
      droppableContainers: s,
      over: i,
      scrollableAncestors: a
    }
  } = t;
  if (os.includes(e.code)) {
    if (e.preventDefault(), !r || !n)
      return;
    const d = [];
    s.getEnabled().forEach((u) => {
      if (!u || u != null && u.disabled)
        return;
      const p = o.get(u.id);
      if (p)
        switch (e.code) {
          case K.Down:
            n.top < p.top && d.push(u);
            break;
          case K.Up:
            n.top > p.top && d.push(u);
            break;
          case K.Left:
            n.left > p.left && d.push(u);
            break;
          case K.Right:
            n.left < p.left && d.push(u);
            break;
        }
    });
    const c = On({
      collisionRect: n,
      droppableRects: o,
      droppableContainers: d
    });
    let f = jr(c, "id");
    if (f === i?.id && c.length > 1 && (f = c[1].id), f != null) {
      const u = s.get(r.id), p = s.get(f), m = p ? o.get(p.id) : null, S = p?.node.current;
      if (S && m && u && p) {
        const b = $t(S).some((A, k) => a[k] !== A), E = en(u, p), _ = as(u, p), D = b || !E ? {
          x: 0,
          y: 0
        } : {
          x: _ ? n.width - m.width : 0,
          y: _ ? n.height - m.height : 0
        }, N = {
          x: m.left,
          y: m.top
        };
        return D.x && D.y ? N : gt(N, D);
      }
    }
  }
};
function en(e, t) {
  return !Ot(e) || !Ot(t) ? !1 : e.data.current.sortable.containerId === t.data.current.sortable.containerId;
}
function as(e, t) {
  return !Ot(e) || !Ot(t) || !en(e, t) ? !1 : e.data.current.sortable.index < t.data.current.sortable.index;
}
const tn = (e) => {
  const t = Math.max(0, Math.min(1, (e - 9) / 26)), r = [
    { threshold: 0, color: "bg-blue-100 border-blue-400 text-blue-800" },
    // 9-12mm: Cold blue
    { threshold: 0.2, color: "bg-cyan-100 border-cyan-400 text-cyan-800" },
    // 13-16mm: Cool cyan
    { threshold: 0.4, color: "bg-emerald-100 border-emerald-400 text-emerald-800" },
    // 17-21mm: Cool green (Dexco-like)
    { threshold: 0.6, color: "bg-yellow-100 border-yellow-400 text-yellow-800" },
    // 22-25mm: Neutral yellow
    { threshold: 0.8, color: "bg-orange-100 border-orange-400 text-orange-800" },
    // 26-30mm: Warm orange
    { threshold: 1, color: "bg-red-100 border-red-400 text-red-800" }
    // 31-35mm: Hot red
  ];
  for (let n = r.length - 1; n >= 0; n--)
    if (t >= r[n].threshold)
      return r[n].color;
  return r[0].color;
}, rn = (e) => {
  const t = Math.max(0, Math.min(1, (e - 9) / 26)), r = [
    { threshold: 0, color: "bg-blue-200 border-blue-500 text-blue-900" },
    // 9-12mm: Cold blue
    { threshold: 0.2, color: "bg-cyan-200 border-cyan-500 text-cyan-900" },
    // 13-16mm: Cool cyan
    { threshold: 0.4, color: "bg-emerald-200 border-emerald-500 text-emerald-900" },
    // 17-21mm: Cool green
    { threshold: 0.6, color: "bg-yellow-200 border-yellow-500 text-yellow-900" },
    // 22-25mm: Neutral yellow
    { threshold: 0.8, color: "bg-orange-200 border-orange-500 text-orange-900" },
    // 26-30mm: Warm orange
    { threshold: 1, color: "bg-red-200 border-red-500 text-red-900" }
    // 31-35mm: Hot red
  ];
  for (let n = r.length - 1; n >= 0; n--)
    if (t >= r[n].threshold)
      return r[n].color;
  return r[0].color;
}, Ds = (e, t) => {
  if (t !== void 0)
    return tn(t);
  const r = [
    "bg-emerald-100 border-emerald-400 text-emerald-800",
    // Dexco primary
    "bg-blue-100 border-blue-400 text-blue-800",
    "bg-cyan-100 border-cyan-400 text-cyan-800",
    "bg-yellow-100 border-yellow-400 text-yellow-800",
    "bg-orange-100 border-orange-400 text-orange-800",
    "bg-red-100 border-red-400 text-red-800",
    "bg-purple-100 border-purple-400 text-purple-800",
    "bg-pink-100 border-pink-400 text-pink-800",
    "bg-indigo-100 border-indigo-400 text-indigo-800",
    "bg-teal-100 border-teal-400 text-teal-800"
  ];
  let n = 0;
  for (let o = 0; o < e.length; o++)
    n = (n << 5) - n + e.charCodeAt(o) & 4294967295;
  return r[Math.abs(n) % r.length];
}, _s = (e, t) => {
  if (t !== void 0)
    return rn(t);
  const r = [
    "bg-emerald-200 border-emerald-500 text-emerald-900",
    // Dexco primary
    "bg-blue-200 border-blue-500 text-blue-900",
    "bg-cyan-200 border-cyan-500 text-cyan-900",
    "bg-yellow-200 border-yellow-500 text-yellow-900",
    "bg-orange-200 border-orange-500 text-orange-900",
    "bg-red-200 border-red-500 text-red-900",
    "bg-purple-200 border-purple-500 text-purple-900",
    "bg-pink-200 border-pink-500 text-pink-900",
    "bg-indigo-200 border-indigo-500 text-indigo-900",
    "bg-teal-200 border-teal-500 text-teal-900"
  ];
  let n = 0;
  for (let o = 0; o < e.length; o++)
    n = (n << 5) - n + e.charCodeAt(o) & 4294967295;
  return r[Math.abs(n) % r.length];
}, nn = ({
  card: e,
  height: t,
  isDragging: r = !1,
  onCardClick: n
}) => {
  const {
    attributes: o,
    listeners: s,
    setNodeRef: i,
    transform: a,
    transition: d,
    isDragging: c
  } = rs({
    id: e.id
    // All cards now have proper IDs
  }), f = {
    transform: We.Transform.toString(a),
    transition: d,
    height: `${Math.max(t, 5)}px`,
    // Minimum height of 5px to ensure small volume cards don't take excessive space
    opacity: r || c ? 0.5 : 1,
    // Critical for mobile touch: use 'none' during drag, 'manipulation' otherwise
    touchAction: r || c ? "none" : "manipulation"
  }, u = (g) => {
    r || c || n && (g.preventDefault(), g.stopPropagation(), n(e));
  }, p = tn(e.prd_espessura), m = rn(e.prd_espessura);
  console.log("🎨 DeliveryCard Debug:", {
    cardId: e.id,
    cliente: e.cli_razao_social.toString(),
    espessura: e.prd_espessura,
    baseColorClasses: p,
    hoverColorClasses: m
  });
  const S = (() => {
    const g = e.prd_espessura, b = Math.max(0, Math.min(1, (g - 9) / 26));
    return b >= 0.8 ? { backgroundColor: "#fee2e2", borderColor: "#ef4444", color: "#7f1d1d" } : b >= 0.6 ? { backgroundColor: "#fed7aa", borderColor: "#f97316", color: "#9a3412" } : b >= 0.4 ? { backgroundColor: "#fef3c7", borderColor: "#f59e0b", color: "#92400e" } : b >= 0.2 ? { backgroundColor: "#d1fae5", borderColor: "#10b981", color: "#064e3b" } : b >= 0 ? { backgroundColor: "#cffafe", borderColor: "#06b6d4", color: "#164e63" } : { backgroundColor: "#dbeafe", borderColor: "#3b82f6", color: "#1e3a8a" };
  })();
  return /* @__PURE__ */ l.jsxs(
    "div",
    {
      ref: i,
      style: {
        ...f,
        ...S
      },
      ...o,
      ...s,
      className: "relative p-1 sm:p-2 mb-0.5 sm:mb-1 rounded-md sm:rounded-lg shadow-sm sm:shadow-md cursor-move border border-solid transition-colors duration-200 overflow-hidden",
      onClick: u,
      role: "button",
      tabIndex: 0,
      "aria-label": `${e.cli_razao_social} - ${e.units.toFixed(2)} m³ - ${e.prd_espessura}mm${e.prd_largura && e.prd_largura > 0 ? ` - L:${e.prd_largura}mm` : ""}${e.prd_comprimento && e.prd_comprimento > 0 ? ` - C:${e.prd_comprimento}mm` : ""}`,
      onKeyDown: (g) => {
        (g.key === "Enter" || g.key === " ") && (g.preventDefault(), n && n(e));
      },
      children: [
        /* @__PURE__ */ l.jsx("div", { className: "font-semibold text-xs sm:text-sm text-gray-800 truncate leading-tight", children: e.cli_razao_social }),
        /* @__PURE__ */ l.jsxs("div", { className: "text-xs sm:text-sm text-gray-700 leading-tight", children: [
          e.units.toFixed(2),
          " m³"
        ] }),
        /* @__PURE__ */ l.jsxs("div", { className: "text-xs text-gray-600 leading-tight", children: [
          e.prd_espessura,
          "mm"
        ] }),
        e.prd_largura && e.prd_largura > 0 && /* @__PURE__ */ l.jsxs("div", { className: "text-xs text-gray-600 leading-tight", children: [
          "L: ",
          e.prd_largura,
          "mm"
        ] }),
        e.prd_comprimento && e.prd_comprimento > 0 && /* @__PURE__ */ l.jsxs("div", { className: "text-xs text-gray-600 leading-tight", children: [
          "C: ",
          e.prd_comprimento,
          "mm"
        ] })
      ]
    }
  );
};
function Ke(e) {
  if (!e || !e.trim())
    throw new Error("Date string is required");
  const t = e.split("T")[0];
  if (!t || !/^\d{4}-\d{2}-\d{2}$/.test(t))
    throw new Error(`Invalid date format: ${e}. Expected YYYY-MM-DD`);
  const [r, n, o] = t.split("-").map(Number);
  if (!r || !n || !o || r < 1900 || n < 1 || n > 12 || o < 1 || o > 31)
    throw new Error(`Invalid date format: ${e}. Expected YYYY-MM-DD`);
  return new Date(r, n - 1, o);
}
function or(e) {
  const t = e.getFullYear(), r = String(e.getMonth() + 1).padStart(2, "0"), n = String(e.getDate()).padStart(2, "0");
  return `${t}-${r}-${n}`;
}
function Ve(e) {
  const t = e.split("T")[0];
  if (!/^\d{4}-\d{2}-\d{2}$/.test(t))
    throw new Error(`Invalid date format: ${e}. Expected YYYY-MM-DD`);
  return t;
}
function is(e) {
  return `${Ve(e)}T00:00:00.000Z`;
}
function sr(e, t) {
  const r = Ve(e), n = Ve(t);
  return r < n ? -1 : r > n ? 1 : 0;
}
function kt() {
  const e = /* @__PURE__ */ new Date(), t = e.getFullYear(), r = e.getMonth(), n = e.getDate();
  return new Date(t, r, n);
}
function ls() {
  return or(kt());
}
const cs = ({
  day: e,
  dayIndex: t,
  maxUnits: r,
  columnHeight: n,
  onCardClick: o,
  onHeaderHeightChange: s,
  quota: i,
  isOverQuota: a,
  vendorTotalVolume: d
}) => {
  const c = J(null);
  _r(() => {
    if (c.current && s) {
      const g = c.current.offsetHeight;
      s(g);
    }
  }, [e.deliveries.length, s]);
  const { setNodeRef: f, isOver: u } = Kr({
    id: `day-${t}-${e.date}`,
    data: {
      type: "day",
      dayIndex: t,
      day: e
    }
  }), p = (g) => {
    if (!g || !g.trim())
      return "Data inválida";
    try {
      const b = Ke(g), E = b.getDate(), _ = b.toLocaleDateString("pt-BR", { month: "short" });
      return `${b.toLocaleDateString("pt-BR", { weekday: "short" })}. ${E}/${_}.`;
    } catch (b) {
      return console.warn(`Invalid date format: ${g}`, b), "Data inválida";
    }
  }, m = d !== void 0 ? d : e.deliveries.filter((g) => g && typeof g.units == "number").reduce((g, b) => g + b.units, 0), S = n - 60;
  return /* @__PURE__ */ l.jsxs(
    "div",
    {
      className: `chart-column border-r border-gray-200 last:border-r-0 transition-colors duration-200 flex flex-col ${a ? "bg-red-50" : ""}`,
      style: {
        boxSizing: "border-box",
        borderRightWidth: "1px",
        borderRightStyle: "solid",
        borderRightColor: a ? "#ef4444" : "#e5e7eb"
      },
      children: [
        /* @__PURE__ */ l.jsxs(
          "div",
          {
            ref: c,
            "data-day-header": !0,
            className: `h-[60px] flex flex-col justify-center items-center p-1 sm:p-2 border-b-2 border-gray-200 relative z-10 overflow-hidden flex-shrink-0 ${a ? "bg-red-100 border-red-300" : "bg-gray-50"}`,
            children: [
              /* @__PURE__ */ l.jsx("div", { className: "font-semibold text-xs sm:text-sm text-gray-800 text-center leading-tight truncate w-full", children: p(e.date) }),
              /* @__PURE__ */ l.jsxs("div", { className: `text-xs text-center leading-tight truncate w-full ${a ? "text-red-700 font-semibold" : "text-gray-600"}`, children: [
                m.toFixed(2),
                " m³",
                i != null && /* @__PURE__ */ l.jsxs("span", { className: `ml-1 ${a ? "text-red-600" : "text-gray-500"}`, children: [
                  "/ ",
                  i.toFixed(2)
                ] })
              ] }),
              e.deliveries.length > 0 && /* @__PURE__ */ l.jsxs("div", { className: "text-xs text-blue-600 text-center leading-tight font-medium truncate w-full", children: [
                e.deliveries.length,
                " ",
                e.deliveries.length === 1 ? "ordem" : "ordens"
              ] }),
              a && /* @__PURE__ */ l.jsx("div", { className: "text-xs text-red-600 text-center leading-tight font-medium truncate w-full", children: "Limite excedido" })
            ]
          }
        ),
        /* @__PURE__ */ l.jsxs(
          "div",
          {
            className: "relative bg-white w-full flex-1",
            style: {
              minHeight: `${S}px`
            },
            "aria-label": `Priorização de entregas para ${p(e.date)}`,
            children: [
              /* @__PURE__ */ l.jsx(
                "div",
                {
                  ref: f,
                  className: `absolute inset-0 transition-colors duration-200 ${u ? "bg-blue-50/30 ring-2 ring-blue-300 pointer-events-auto" : "pointer-events-none"}`,
                  style: {
                    touchAction: "manipulation",
                    zIndex: 1
                    // Below cards but above background
                  },
                  children: u && /* @__PURE__ */ l.jsx("div", { className: "absolute inset-0 bg-blue-50 border-2 border-dashed border-blue-300 rounded-md pointer-events-none z-20", children: /* @__PURE__ */ l.jsx("div", { className: "absolute inset-0 flex items-center justify-center", children: /* @__PURE__ */ l.jsx("div", { className: "text-blue-600 text-sm font-medium bg-white px-3 py-1 rounded-md shadow-sm", children: "Solte aqui" }) }) })
                }
              ),
              e.deliveries.length === 0 && !u && /* @__PURE__ */ l.jsx("div", { className: "absolute inset-0 flex items-center justify-center text-gray-400 text-xs sm:text-sm px-1 text-center leading-tight z-0", children: "Nenhuma entrega programada" }),
              /* @__PURE__ */ l.jsx(
                "div",
                {
                  className: "relative flex flex-col justify-start w-full h-full overflow-y-auto scroll-smooth p-1 sm:p-2",
                  style: {
                    scrollbarWidth: "thin",
                    scrollbarColor: "#CBD5E0 transparent",
                    minHeight: `${S}px`,
                    zIndex: 10
                    // Above overlay for card interactions
                  },
                  children: /* @__PURE__ */ l.jsx(
                    Ko,
                    {
                      items: e.deliveries.filter((g) => g && g.id).map((g, b) => g.id || `temp-${t}-${b}`),
                      strategy: Ho,
                      children: /* @__PURE__ */ l.jsxs("div", { className: "flex flex-col flex-1 w-full", children: [
                        e.deliveries.filter((g) => g && g.id && typeof g.units == "number").map((g) => {
                          const E = e.deliveries.filter((N) => N && typeof N.units == "number").reduce((N, T) => N + T.units, 0), _ = S - 16;
                          let D;
                          return E <= r ? D = g.units / r * _ : D = g.units / E * _, D = Math.max(20, D), /* @__PURE__ */ l.jsx(
                            nn,
                            {
                              card: g,
                              height: D,
                              onCardClick: o
                            },
                            g.id || `temp-${t}-${e.deliveries.indexOf(g)}`
                          );
                        }),
                        /* @__PURE__ */ l.jsx("div", { className: "flex-1 min-h-4" })
                      ] })
                    }
                  )
                }
              )
            ]
          }
        )
      ]
    }
  );
}, ds = ({
  maxUnits: e,
  height: t,
  headerHeight: r = 60,
  gridInterval: n = 50
}) => {
  const o = q(() => {
    const i = [];
    for (let a = 0; a <= e; a += n)
      i.push(a);
    return i;
  }, [e, n]), s = t - r;
  return /* @__PURE__ */ l.jsxs("div", { className: "w-16 relative bg-gray-50 border-r-2 border-gray-200 flex-shrink-0", children: [
    /* @__PURE__ */ l.jsx("div", { className: "h-[60px] flex items-center justify-center text-xs font-medium text-gray-600 border-b-2 border-gray-200", children: /* @__PURE__ */ l.jsx("span", { className: "transform -rotate-90 whitespace-nowrap", children: "Volume (m³)" }) }),
    /* @__PURE__ */ l.jsx(
      "div",
      {
        className: "relative",
        style: {
          height: s,
          paddingTop: `${r - 60}px`
          // Dynamic offset based on actual header height
        },
        children: o.map((i) => {
          const a = e === 0 ? 0 : i / e * 100;
          return /* @__PURE__ */ l.jsxs(
            "div",
            {
              className: "absolute right-0 flex items-center",
              style: {
                top: `${a}%`,
                transform: "translateY(-50%)",
                width: "100%"
              },
              children: [
                /* @__PURE__ */ l.jsx("div", { className: "absolute left-0 w-full h-px bg-gray-200 opacity-50" }),
                /* @__PURE__ */ l.jsx("div", { className: "text-xs text-gray-500 pr-2 bg-gray-50 relative z-10", children: i % 1 === 0 ? i : i.toFixed(1) })
              ]
            },
            i
          );
        })
      }
    )
  ] });
}, us = ({
  card: e,
  isOpen: t,
  onClose: r,
  onSplit: n,
  onDateChange: o,
  availableDates: s,
  currentColumnDate: i,
  userInfo: a,
  onShowToast: d,
  getQuotaForDate: c,
  monthState: f
}) => {
  const [u, p] = Y(""), [m, S] = Y(!1), [g, b] = Y(() => Ve(e.dt_producao)), E = (y) => {
    try {
      const j = Ke(y), G = kt();
      return j < G;
    } catch (j) {
      return console.warn("Error parsing date for validation:", j), !1;
    }
  }, _ = () => {
    if (!a || a.profile_type === "diretor")
      return !0;
    if (a.profile_type === "vendedor") {
      const y = a.full_name.toLowerCase(), j = e.no_vendedor?.toLowerCase() || "";
      return y === j || y.includes(j) || j.includes(y);
    }
    return !1;
  }, D = (y) => {
    const j = E(y), G = Ke(y), oe = kt();
    if (console.log("📅 [DATE VALIDATION]", {
      newDate: y,
      selectedDate: G.toDateString(),
      today: oe.toDateString(),
      todayString: ls(),
      isPastDate: j,
      selectedTime: G.getTime(),
      todayTime: oe.getTime(),
      timeDiff: G.getTime() - oe.getTime()
    }), j)
      return d?.("Não é possível mover cards para datas anteriores a hoje (ontem ou antes)", "warning"), !1;
    if (!_())
      return d?.("Você só pode modificar cards do seu próprio vendedor", "error"), !1;
    if (a?.profile_type === "vendedor" && c && f) {
      const ne = c(y);
      if (ne !== null) {
        const me = f.find((le) => le.date === y), we = a.full_name.toLowerCase(), se = me?.deliveries.filter((le) => {
          if (!le || typeof le.units != "number" || le.id === e.id) return !1;
          const h = le.no_vendedor?.toLowerCase() || "";
          return we === h || we.includes(h) || h.includes(we);
        }).reduce((le, h) => le + h.units, 0) || 0, Ee = se + e.units;
        if (Ee > ne)
          return d?.(`Operação bloqueada: limite de ${ne.toFixed(2)} m³ seria excedido (atual: ${se.toFixed(2)} m³ + ${e.units.toFixed(2)} m³ = ${Ee.toFixed(2)} m³)`, "warning"), !1;
      }
    }
    return !0;
  }, N = () => _() ? !0 : (d?.("Você só pode dividir cards do seu próprio vendedor", "error"), !1), T = () => {
    p(""), S(!1), r();
  };
  F(() => {
    if (t) {
      const y = window.history.state;
      if (!y?.modalOpen || y?.cardId !== e.id) {
        const G = { modalOpen: !0, cardId: e.id, previousUrl: window.location.href };
        window.history.pushState(G, "", window.location.href);
      }
      const j = (G) => {
        G.state?.modalOpen || T();
      };
      return window.addEventListener("popstate", j), () => {
        window.removeEventListener("popstate", j);
      };
    }
  }, [t, e.id, r]);
  const A = () => {
    window.history.state?.modalOpen ? window.history.back() : T();
  };
  F(() => {
    const y = (j) => {
      j.key === "Escape" && t && A();
    };
    if (t)
      return document.addEventListener("keydown", y), document.body.style.overflow = "hidden", () => {
        document.removeEventListener("keydown", y), document.body.style.overflow = "unset";
      };
  }, [t]), F(() => {
    if (t && i) {
      const y = i.split("T")[0];
      b(y);
    }
  }, [t, i]);
  const k = (y) => {
    if (!D(y)) {
      b(Ve(e.dt_producao));
      return;
    }
    b(y), o?.(e, y), r();
  }, M = (y) => {
    p(y);
    const j = parseFloat(y), G = !isNaN(j) && j > 0 && j < e.units && j !== e.units;
    S(G);
  }, Z = () => {
    if (!N())
      return;
    const y = parseFloat(u);
    m && (n(e, y), p(""), r());
  };
  return t ? /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsx(
      "div",
      {
        className: "fixed inset-0 bg-black/50 transition-opacity duration-200 modal-backdrop",
        style: {
          backdropFilter: "blur(4px)",
          zIndex: 99998
        },
        onClick: A
      }
    ),
    /* @__PURE__ */ l.jsx(
      "div",
      {
        className: "fixed inset-0 flex items-start justify-center p-4 modal-container overflow-y-auto relative",
        style: {
          zIndex: 99999,
          paddingTop: "2rem",
          paddingBottom: "2rem"
        },
        onClick: (y) => {
          y.target === y.currentTarget && A();
        },
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": "modal-title",
        "aria-describedby": "modal-description",
        children: /* @__PURE__ */ l.jsx("div", { className: "relative w-full max-w-2xl my-auto", children: /* @__PURE__ */ l.jsxs(
          "div",
          {
            className: "bg-white rounded-xl shadow-2xl w-full relative modal-content",
            onClick: (y) => y.stopPropagation(),
            style: {
              boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(0, 0, 0, 0.05)",
              zIndex: 1e5,
              maxHeight: "calc(100vh - 4rem)",
              overflowY: "auto"
            },
            children: [
              /* @__PURE__ */ l.jsx("div", { className: "px-6 py-5 border-b border-gray-200 bg-gradient-to-r from-emerald-50 to-cyan-50", children: /* @__PURE__ */ l.jsxs("div", { className: "flex justify-between items-center", children: [
                /* @__PURE__ */ l.jsxs("div", { className: "min-w-0 flex-1 mr-4", children: [
                  /* @__PURE__ */ l.jsx("h2", { id: "modal-title", className: "text-xl font-semibold text-gray-900", children: "Detalhes do Pedido" }),
                  /* @__PURE__ */ l.jsxs("p", { id: "modal-description", className: "text-sm text-gray-600", children: [
                    e.cli_razao_social,
                    " • ",
                    e.units.toFixed(2),
                    " m³"
                  ] })
                ] }),
                /* @__PURE__ */ l.jsx("div", { className: "flex-shrink-0", children: /* @__PURE__ */ l.jsx(
                  "button",
                  {
                    onClick: A,
                    className: "w-8 h-8 flex items-center justify-center text-gray-500 hover:text-gray-700 hover:bg-white/70 rounded-full transition-colors duration-200",
                    "aria-label": "Fechar modal",
                    children: /* @__PURE__ */ l.jsx("svg", { className: "w-5 h-5", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: /* @__PURE__ */ l.jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M6 18L18 6M6 6l12 12" }) })
                  }
                ) })
              ] }) }),
              /* @__PURE__ */ l.jsxs("div", { className: "p-6 space-y-6", children: [
                /* @__PURE__ */ l.jsxs("div", { className: "space-y-4", children: [
                  /* @__PURE__ */ l.jsxs("div", { children: [
                    /* @__PURE__ */ l.jsx("label", { className: "text-sm font-medium text-gray-700", children: "Nome do Produto" }),
                    /* @__PURE__ */ l.jsx("p", { className: "text-gray-900 font-medium", children: e.productName })
                  ] }),
                  /* @__PURE__ */ l.jsxs("div", { className: "grid grid-cols-2 gap-4", children: [
                    /* @__PURE__ */ l.jsxs("div", { children: [
                      /* @__PURE__ */ l.jsx("label", { className: "text-sm font-medium text-gray-700", children: "Linha do Produto" }),
                      /* @__PURE__ */ l.jsx("p", { className: "text-gray-900", children: e.prd_dc_linha })
                    ] }),
                    /* @__PURE__ */ l.jsxs("div", { children: [
                      /* @__PURE__ */ l.jsx("label", { className: "text-sm font-medium text-gray-700", children: "Volume" }),
                      /* @__PURE__ */ l.jsxs("p", { className: "text-lg font-semibold text-blue-600", children: [
                        e.units.toFixed(2),
                        " m³"
                      ] })
                    ] })
                  ] }),
                  /* @__PURE__ */ l.jsxs("div", { className: "grid grid-cols-3 gap-4", children: [
                    /* @__PURE__ */ l.jsxs("div", { children: [
                      /* @__PURE__ */ l.jsx("label", { className: "text-sm font-medium text-gray-700", children: "Espessura" }),
                      /* @__PURE__ */ l.jsxs("p", { className: "text-gray-900", children: [
                        e.prd_espessura,
                        "mm"
                      ] })
                    ] }),
                    /* @__PURE__ */ l.jsxs("div", { children: [
                      /* @__PURE__ */ l.jsx("label", { className: "text-sm font-medium text-gray-700", children: "Largura" }),
                      /* @__PURE__ */ l.jsx("p", { className: "text-gray-900", children: e.prd_largura ? `${e.prd_largura.toFixed(2)}mm` : "Não informado" })
                    ] }),
                    /* @__PURE__ */ l.jsxs("div", { children: [
                      /* @__PURE__ */ l.jsx("label", { className: "text-sm font-medium text-gray-700", children: "Comprimento" }),
                      /* @__PURE__ */ l.jsx("p", { className: "text-gray-900", children: e.prd_comprimento ? `${e.prd_comprimento.toFixed(2)}mm` : "Não informado" })
                    ] })
                  ] }),
                  /* @__PURE__ */ l.jsxs("div", { className: "grid grid-cols-2 gap-4", children: [
                    /* @__PURE__ */ l.jsxs("div", { children: [
                      /* @__PURE__ */ l.jsx("label", { className: "text-sm font-medium text-gray-700", children: "Cliente" }),
                      /* @__PURE__ */ l.jsx("p", { className: "text-gray-900", children: e.client })
                    ] }),
                    /* @__PURE__ */ l.jsxs("div", { children: [
                      /* @__PURE__ */ l.jsx("label", { className: "text-sm font-medium text-gray-700", children: "Vendedor" }),
                      /* @__PURE__ */ l.jsx("p", { className: "text-gray-900", children: e.no_vendedor })
                    ] })
                  ] })
                ] }),
                /* @__PURE__ */ l.jsxs("div", { className: "border-t border-gray-200 pt-6 space-y-4", children: [
                  /* @__PURE__ */ l.jsx("h3", { className: "font-semibold text-gray-800", children: "Identificação do Card" }),
                  /* @__PURE__ */ l.jsxs("div", { className: "grid grid-cols-2 gap-4", children: [
                    /* @__PURE__ */ l.jsxs("div", { children: [
                      /* @__PURE__ */ l.jsx("label", { className: "text-sm font-medium text-gray-700", children: "ID do Card" }),
                      /* @__PURE__ */ l.jsx("p", { className: "text-gray-900 font-mono text-sm bg-gray-50 px-3 py-2 rounded", children: e.id })
                    ] }),
                    /* @__PURE__ */ l.jsxs("div", { children: [
                      /* @__PURE__ */ l.jsx("label", { className: "text-sm font-medium text-gray-700", children: "ID Original" }),
                      /* @__PURE__ */ l.jsx("p", { className: "text-gray-900 font-mono text-sm bg-gray-50 px-3 py-2 rounded", children: e.parent_id || e.id })
                    ] })
                  ] })
                ] }),
                /* @__PURE__ */ l.jsxs("div", { className: "border-t border-gray-200 pt-6 space-y-4", children: [
                  /* @__PURE__ */ l.jsx("h3", { className: "font-semibold text-gray-800", children: "Informações do Pedido" }),
                  /* @__PURE__ */ l.jsxs("div", { className: "grid grid-cols-3 gap-4", children: [
                    /* @__PURE__ */ l.jsxs("div", { children: [
                      /* @__PURE__ */ l.jsx("label", { className: "text-sm font-medium text-gray-700", children: "Número do Pedido" }),
                      /* @__PURE__ */ l.jsxs("p", { className: "text-gray-900", children: [
                        "#",
                        e.ordem
                      ] })
                    ] }),
                    /* @__PURE__ */ l.jsxs("div", { children: [
                      /* @__PURE__ */ l.jsx("label", { className: "text-sm font-medium text-gray-700", children: "Item" }),
                      /* @__PURE__ */ l.jsx("p", { className: "text-gray-900", children: e.item })
                    ] }),
                    /* @__PURE__ */ l.jsxs("div", { children: [
                      /* @__PURE__ */ l.jsx("label", { className: "text-sm font-medium text-gray-700", children: "Centro" }),
                      /* @__PURE__ */ l.jsx("p", { className: "text-gray-900", children: e.centro })
                    ] })
                  ] }),
                  /* @__PURE__ */ l.jsxs("div", { children: [
                    /* @__PURE__ */ l.jsx("label", { className: "text-sm font-medium text-gray-700", children: "Código do Produto" }),
                    /* @__PURE__ */ l.jsx("p", { className: "text-gray-900 font-mono", children: e.cd_produto })
                  ] })
                ] }),
                /* @__PURE__ */ l.jsxs("div", { className: "border-t border-gray-200 pt-6 space-y-4", children: [
                  /* @__PURE__ */ l.jsx("h3", { className: "font-semibold text-gray-800", children: "Datas Importantes" }),
                  /* @__PURE__ */ l.jsxs("div", { className: "grid grid-cols-2 gap-4", children: [
                    /* @__PURE__ */ l.jsxs("div", { children: [
                      /* @__PURE__ */ l.jsx("label", { className: "text-sm font-medium text-gray-700", children: "Data de Emissão" }),
                      /* @__PURE__ */ l.jsx("p", { className: "text-gray-900", children: (() => {
                        if (e.dt_emissao && e.dt_emissao.trim())
                          try {
                            return Ke(e.dt_emissao).toLocaleDateString();
                          } catch (y) {
                            return console.warn(`Invalid dt_emissao: ${e.dt_emissao}`, y), "Data inválida";
                          }
                        return "Não informado";
                      })() })
                    ] }),
                    /* @__PURE__ */ l.jsxs("div", { children: [
                      /* @__PURE__ */ l.jsx("label", { className: "text-sm font-medium text-gray-700", children: "Data desejada da remessa" }),
                      /* @__PURE__ */ l.jsx("p", { className: "text-gray-900", children: e.dt_desejada_remessa ? Ke(e.dt_desejada_remessa).toLocaleDateString() : e.dt_preparacao_material ? Ke(e.dt_preparacao_material).toLocaleDateString() : "Data não disponível" })
                    ] })
                  ] }),
                  /* @__PURE__ */ l.jsxs("div", { children: [
                    /* @__PURE__ */ l.jsxs("label", { className: "block text-sm font-medium text-gray-700 mb-2", children: [
                      "Data de produção",
                      !_() && /* @__PURE__ */ l.jsx("span", { className: "ml-2 text-xs text-red-600", children: "(Sem permissão para editar)" })
                    ] }),
                    /* @__PURE__ */ l.jsx(
                      "select",
                      {
                        value: g,
                        onChange: (y) => k(y.target.value),
                        disabled: !_(),
                        className: `w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent ${_() ? "" : "bg-gray-100 text-gray-400 cursor-not-allowed"}`,
                        children: s.filter((y) => a?.profile_type === "vendedor" ? !E(y) : !0).map((y) => /* @__PURE__ */ l.jsx("option", { value: y, children: (() => {
                          if (y && y.trim())
                            try {
                              const j = Ke(y), G = E(y), oe = j.toLocaleDateString("pt-BR", {
                                weekday: "short",
                                day: "2-digit",
                                month: "short"
                              });
                              return G ? `${oe} (passado)` : oe;
                            } catch (j) {
                              return console.warn(`Invalid date in options: ${y}`, j), y;
                            }
                          return "Data inválida";
                        })() }, y))
                      }
                    ),
                    /* @__PURE__ */ l.jsx("p", { className: "text-xs text-gray-500 mt-1", children: "Alterar esta data moverá o card para a coluna correspondente" })
                  ] })
                ] }),
                /* @__PURE__ */ l.jsxs("div", { className: "border-t border-gray-200 pt-6 space-y-4", children: [
                  /* @__PURE__ */ l.jsxs("h3", { className: "font-semibold text-gray-800", children: [
                    "Dividir Card",
                    !_() && /* @__PURE__ */ l.jsx("span", { className: "ml-2 text-xs text-red-600", children: "(Sem permissão para dividir)" })
                  ] }),
                  /* @__PURE__ */ l.jsx("p", { className: "text-sm text-gray-600", children: "Dividir este card em dois cards separados. Digite o volume para o novo card." }),
                  /* @__PURE__ */ l.jsxs("div", { children: [
                    /* @__PURE__ */ l.jsx("label", { className: "block text-sm font-medium text-gray-700 mb-2", children: "Volume do Novo Card (m³)" }),
                    /* @__PURE__ */ l.jsx(
                      "input",
                      {
                        type: "number",
                        value: u,
                        onChange: (y) => M(y.target.value),
                        placeholder: `Digite um valor menor que ${e.units.toFixed(2)}`,
                        step: "0.01",
                        min: "0.01",
                        max: e.units - 0.01,
                        disabled: !_(),
                        className: `w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent ${_() ? "" : "bg-gray-100 text-gray-400 cursor-not-allowed"}`
                      }
                    ),
                    u && !m && /* @__PURE__ */ l.jsxs("p", { className: "text-sm text-red-600 mt-2", children: [
                      "O volume deve ser maior que 0 e menor que ",
                      e.units.toFixed(2),
                      " m³"
                    ] }),
                    m && /* @__PURE__ */ l.jsx("div", { className: "mt-2 p-3 bg-green-50 rounded-md", children: /* @__PURE__ */ l.jsxs("p", { className: "text-sm text-green-700", children: [
                      /* @__PURE__ */ l.jsx("strong", { children: "Prévia da Divisão:" }),
                      /* @__PURE__ */ l.jsx("br", {}),
                      "Card original: ",
                      (e.units - parseFloat(u)).toFixed(2),
                      " m³",
                      /* @__PURE__ */ l.jsx("br", {}),
                      "Novo card: ",
                      parseFloat(u).toFixed(2),
                      " m³"
                    ] }) })
                  ] })
                ] })
              ] }),
              /* @__PURE__ */ l.jsx("div", { className: "flex items-center justify-end gap-4 px-6 py-4 border-t border-gray-200 bg-gray-50", children: /* @__PURE__ */ l.jsxs("div", { className: "flex items-center gap-3", children: [
                /* @__PURE__ */ l.jsx(
                  "button",
                  {
                    onClick: A,
                    className: "px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors duration-200 font-medium",
                    children: "Fechar"
                  }
                ),
                /* @__PURE__ */ l.jsx(
                  "button",
                  {
                    onClick: Z,
                    disabled: !m || !_(),
                    className: `px-4 py-2 rounded-lg transition-colors duration-200 font-medium ${m && _() ? "bg-emerald-100 text-emerald-700 hover:bg-emerald-200 hover:text-emerald-800 shadow-sm" : "bg-gray-200 text-gray-400 cursor-not-allowed"}`,
                    children: "Dividir Card"
                  }
                )
              ] }) })
            ]
          }
        ) })
      }
    )
  ] }) : null;
}, fs = ({
  filterOptions: e,
  activeFilters: t,
  onFiltersChange: r,
  isLoading: n,
  userInfo: o,
  onShowToast: s
}) => {
  const [i, a] = Y(""), [d, c] = Y(""), [f, u] = Y(""), [p, m] = Y(""), [S, g] = Y(!1), [b, E] = Y(!1), [_, D] = Y(null), N = J(null), T = J(null), A = e.vendedores.filter(
    (C) => C.toLowerCase().includes(f.toLowerCase())
  ), k = e.clientes.filter(
    (C) => C.toLowerCase().includes(p.toLowerCase())
  );
  ue.useEffect(() => {
    e.clientes.length > 0 && console.log("📋 [CLIENT FILTER] Available clients:", e.clientes.slice(0, 10), "... (showing first 10)");
  }, [e.clientes]), F(() => {
    const C = (z) => {
      N.current && !N.current.contains(z.target) && g(!1), T.current && !T.current.contains(z.target) && E(!1);
    };
    return document.addEventListener("mousedown", C), () => document.removeEventListener("mousedown", C);
  }, []), F(() => {
    u(t.vendedor);
  }, [t.vendedor]), F(() => {
    m(t.cliente);
  }, [t.cliente]), F(() => {
    if (o && o.profile_type === "vendedor" && e.vendedores.length > 0) {
      const C = o.full_name;
      if (console.log(`🔍 [VENDEDOR FILTER] Starting auto-filter for user: "${C}"`), console.log(`📊 [VENDEDOR FILTER] Current active filter: "${t.vendedor}"`), console.log("📋 [VENDEDOR FILTER] Available vendedores:", e.vendedores), t.vendedor) {
        console.log(`⏭️ [VENDEDOR FILTER] Filter already active: "${t.vendedor}", skipping auto-apply`);
        return;
      }
      const z = (U) => U.toLowerCase().trim().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, " "), ce = z(C);
      console.log(`🔍 [VENDEDOR FILTER] Looking for match: "${C}" (normalized: "${ce}")`), console.log(`📋 [VENDEDOR FILTER] Testing against ${e.vendedores.length} vendedores`);
      let ve = e.vendedores.find((U) => {
        const $ = z(U) === ce;
        return $ && console.log(`✅ [EXACT] Match found: "${U}" === "${C}"`), $;
      });
      if (ve || (console.log("🔍 [PARTIAL] No exact match, trying partial matching..."), ve = e.vendedores.find((U) => {
        const W = z(U), $ = W.includes(ce) || ce.includes(W);
        return $ && console.log(`🔍 [PARTIAL] Match found: "${U}" ⟷ "${C}"`), $;
      })), !ve) {
        console.log("🎯 [WORD] No partial match, trying word-by-word matching...");
        const U = ce.split(" ").filter((W) => W.length > 2);
        console.log(`🎯 [WORD] User words: [${U.join(", ")}]`), ve = e.vendedores.find((W) => {
          const $ = z(W).split(" ").filter((Se) => Se.length > 2), Ae = U.filter(
            (Se) => $.some((Le) => Se === Le)
          ), ge = Ae.length / Math.max(U.length, 1), Ie = Ae.length > 0 && ge >= 0.5;
          return Ie && (console.log(`🎯 [WORD] Match found: "${W}" ⟷ "${C}" (${Ae.length}/${U.length} words, ${(ge * 100).toFixed(0)}%)`), console.log(`🎯 [WORD] Matched words: [${Ae.join(", ")}]`)), Ie;
        });
      }
      ve && !t.vendedor ? (console.log(`🔐 [APPLY] Applying vendedor filter: "${ve}" for user: "${C}"`), r({
        ...t,
        vendedor: ve
      }), D(null)) : ve ? (console.log(`⏭️ [SKIP] Filter already exists: "${t.vendedor}"`), D(null)) : (console.error(`❌ [ERROR] Vendedor não encontrado para o usuário: "${C}"`), console.error("📋 [ERROR] Opções disponíveis:", e.vendedores), D(`Vendedor "${C}" não foi encontrado no sistema. Entre em contato com o administrador.`));
    }
  }, [o, e.vendedores, t, r]);
  const M = (C) => {
    if (o?.profile_type === "vendedor" && !C && t.vendedor) {
      s?.("Usuários limitados não podem remover o filtro de vendedor", "warning");
      return;
    }
    u(C), g(!1), r({
      ...t,
      vendedor: C
    });
  }, Z = (C) => {
    console.log("🏢 [CLIENT FILTER] Applying client filter:", C), m(C), E(!1), r({
      ...t,
      cliente: C
    });
  }, y = (C) => {
    if (u(C), g(!0), !C.trim()) {
      if (o?.profile_type === "vendedor" && t.vendedor) {
        s?.("Usuários limitados não podem remover o filtro de vendedor", "warning"), u(t.vendedor);
        return;
      }
      r({
        ...t,
        vendedor: ""
      });
    }
  }, j = (C) => {
    m(C), E(!0), C.trim() || r({
      ...t,
      cliente: ""
    });
  }, G = (C) => {
    C.key === "Enter" && A.length > 0 ? M(A[0]) : C.key === "Escape" && g(!1);
  }, oe = (C) => {
    C.key === "Enter" && k.length > 0 ? Z(k[0]) : C.key === "Escape" && E(!1);
  }, ne = (C) => {
    const z = C.replace(/[^0-9.]/g, "");
    (z.match(/\./g) || []).length <= 1 && a(z);
  }, me = () => {
    r({
      ...t,
      espessura: i.trim()
    });
  }, we = () => {
    a(""), r({
      ...t,
      espessura: ""
    });
  }, se = (C) => {
    C.key === "Enter" && me();
  }, Ee = (C) => {
    const z = C.replace(/[^0-9.]/g, "");
    (z.match(/\./g) || []).length <= 1 && c(z);
  }, le = () => {
    r({
      ...t,
      largura: d.trim()
    });
  }, h = () => {
    c(""), r({
      ...t,
      largura: ""
    });
  }, P = (C) => {
    C.key === "Enter" && le();
  }, B = () => {
    if (o?.profile_type === "vendedor" && t.vendedor) {
      s?.("Usuários limitados não podem limpar o filtro de vendedor", "warning"), a(""), c(""), r({
        vendedor: t.vendedor,
        // Keep current vendedor filter
        cliente: "",
        espessura: "",
        largura: ""
      });
      return;
    }
    a(""), c(""), r({
      vendedor: "",
      cliente: "",
      espessura: "",
      largura: ""
    });
  }, ee = t.vendedor || t.cliente || t.espessura || t.largura;
  return /* @__PURE__ */ l.jsx("div", { className: "border-b border-gray-200 p-3 sm:p-4 bg-gray-50", children: /* @__PURE__ */ l.jsxs("div", { className: "flex flex-col gap-3", children: [
    /* @__PURE__ */ l.jsxs("div", { className: "flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3", children: [
      /* @__PURE__ */ l.jsx("span", { className: "text-sm font-medium text-gray-700 flex-shrink-0", children: "Filtros:" }),
      ee && !n && /* @__PURE__ */ l.jsxs(
        "button",
        {
          onClick: B,
          className: "px-3 py-2 text-sm text-gray-600 hover:text-gray-800 hover:bg-gray-200 rounded-md transition-colors flex items-center gap-1 flex-shrink-0",
          title: "Limpar filtros",
          children: [
            /* @__PURE__ */ l.jsx("svg", { className: "w-4 h-4", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: /* @__PURE__ */ l.jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M6 18L18 6M6 6l12 12" }) }),
            "Limpar"
          ]
        }
      )
    ] }),
    _ && /* @__PURE__ */ l.jsx("div", { className: "bg-red-50 border border-red-200 rounded-md p-3 mb-3", children: /* @__PURE__ */ l.jsxs("div", { className: "flex items-start gap-2", children: [
      /* @__PURE__ */ l.jsx("svg", { className: "w-5 h-5 text-red-500 mt-0.5 flex-shrink-0", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: /* @__PURE__ */ l.jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" }) }),
      /* @__PURE__ */ l.jsxs("div", { className: "text-sm", children: [
        /* @__PURE__ */ l.jsx("p", { className: "font-medium text-red-800", children: "Vendedor não encontrado" }),
        /* @__PURE__ */ l.jsx("p", { className: "text-red-700", children: _ })
      ] })
    ] }) }),
    /* @__PURE__ */ l.jsxs("div", { className: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 w-full", children: [
      /* @__PURE__ */ l.jsxs("div", { className: "flex flex-col gap-1", ref: N, children: [
        /* @__PURE__ */ l.jsx("label", { htmlFor: "vendedor-filter", className: "text-xs text-gray-600", children: "Vendedor" }),
        /* @__PURE__ */ l.jsxs("div", { className: "relative", children: [
          /* @__PURE__ */ l.jsx(
            "input",
            {
              id: "vendedor-filter",
              type: "text",
              value: f,
              onChange: (C) => y(C.target.value),
              onKeyDown: G,
              onFocus: () => g(!0),
              disabled: n || o?.profile_type === "vendedor",
              placeholder: n ? "Carregando..." : o?.profile_type === "vendedor" ? "Filtro pré-definido para seu usuário" : "Digite ou selecione vendedor",
              className: `px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent w-full ${n || o?.profile_type === "vendedor" ? "bg-gray-100 text-gray-400 cursor-not-allowed" : "bg-white text-gray-900"}`
            }
          ),
          S && !n && A.length > 0 && /* @__PURE__ */ l.jsx("div", { className: "absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-48 overflow-y-auto", style: { backgroundColor: "white !important" }, children: A.map((C) => /* @__PURE__ */ l.jsx(
            "button",
            {
              onClick: () => M(C),
              className: "w-full px-3 py-2 text-left text-sm text-gray-900 hover:bg-blue-50 focus:bg-blue-50 focus:outline-none border-0 bg-transparent first:rounded-t-md last:rounded-b-md block",
              style: {
                backgroundColor: "white",
                color: "#111827",
                border: "none",
                borderRadius: "0",
                fontSize: "14px",
                fontWeight: "normal"
              },
              onMouseEnter: (z) => {
                z.currentTarget.style.backgroundColor = "#dbeafe", z.currentTarget.style.color = "#111827";
              },
              onMouseLeave: (z) => {
                z.currentTarget.style.backgroundColor = "white", z.currentTarget.style.color = "#111827";
              },
              children: C
            },
            C
          )) })
        ] })
      ] }),
      /* @__PURE__ */ l.jsxs("div", { className: "flex flex-col gap-1", ref: T, children: [
        /* @__PURE__ */ l.jsx("label", { htmlFor: "cliente-filter", className: "text-xs text-gray-600", children: "Cliente" }),
        /* @__PURE__ */ l.jsxs("div", { className: "relative", children: [
          /* @__PURE__ */ l.jsx(
            "input",
            {
              id: "cliente-filter",
              type: "text",
              value: p,
              onChange: (C) => j(C.target.value),
              onKeyDown: oe,
              onFocus: () => E(!0),
              disabled: n,
              placeholder: n ? "Carregando..." : "Digite ou selecione cliente",
              className: `px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent w-full ${n ? "bg-gray-100 text-gray-400 cursor-not-allowed" : "bg-white text-gray-900"}`
            }
          ),
          b && !n && k.length > 0 && /* @__PURE__ */ l.jsx("div", { className: "absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-48 overflow-y-auto", style: { backgroundColor: "white !important" }, children: k.map((C) => /* @__PURE__ */ l.jsx(
            "button",
            {
              onClick: () => Z(C),
              className: "w-full px-3 py-2 text-left text-sm text-gray-900 hover:bg-green-50 focus:bg-green-50 focus:outline-none border-0 bg-transparent first:rounded-t-md last:rounded-b-md block",
              style: {
                backgroundColor: "white",
                color: "#111827",
                border: "none",
                borderRadius: "0",
                fontSize: "14px",
                fontWeight: "normal"
              },
              onMouseEnter: (z) => {
                z.currentTarget.style.backgroundColor = "#dcfce7", z.currentTarget.style.color = "#111827";
              },
              onMouseLeave: (z) => {
                z.currentTarget.style.backgroundColor = "white", z.currentTarget.style.color = "#111827";
              },
              children: C
            },
            C
          )) })
        ] })
      ] }),
      /* @__PURE__ */ l.jsxs("div", { className: "flex flex-col gap-1", children: [
        /* @__PURE__ */ l.jsx("label", { htmlFor: "espessura-filter", className: "text-xs text-gray-600", children: "Espessura" }),
        /* @__PURE__ */ l.jsxs("div", { className: "flex items-center gap-1", children: [
          /* @__PURE__ */ l.jsx(
            "input",
            {
              id: "espessura-filter",
              type: "text",
              value: i,
              onChange: (C) => ne(C.target.value),
              onKeyPress: se,
              disabled: n,
              placeholder: "Ex: 6",
              className: `px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent flex-1 min-w-0 ${n ? "bg-gray-100 text-gray-400 cursor-not-allowed" : "bg-white text-gray-900"}`
            }
          ),
          /* @__PURE__ */ l.jsx(
            "button",
            {
              onClick: me,
              disabled: n || !i.trim(),
              className: `px-2 py-2 text-sm rounded-md transition-colors flex items-center justify-center flex-shrink-0 ${n || !i.trim() ? "bg-gray-100 text-gray-400 cursor-not-allowed" : "bg-blue-500 text-white hover:bg-blue-600"}`,
              title: "Confirmar filtro de espessura",
              children: /* @__PURE__ */ l.jsx("svg", { className: "w-4 h-4", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: /* @__PURE__ */ l.jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M5 13l4 4L19 7" }) })
            }
          ),
          t.espessura && /* @__PURE__ */ l.jsx(
            "button",
            {
              onClick: we,
              className: "px-2 py-2 text-sm text-gray-600 hover:text-gray-800 hover:bg-gray-200 rounded-md transition-colors flex-shrink-0",
              title: "Limpar filtro de espessura",
              children: /* @__PURE__ */ l.jsx("svg", { className: "w-4 h-4", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: /* @__PURE__ */ l.jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M6 18L18 6M6 6l12 12" }) })
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ l.jsxs("div", { className: "flex flex-col gap-1", children: [
        /* @__PURE__ */ l.jsx("label", { htmlFor: "largura-filter", className: "text-xs text-gray-600", children: "Largura (mm)" }),
        /* @__PURE__ */ l.jsxs("div", { className: "flex items-center gap-1", children: [
          /* @__PURE__ */ l.jsx(
            "input",
            {
              id: "largura-filter",
              type: "text",
              value: d,
              onChange: (C) => Ee(C.target.value),
              onKeyPress: P,
              disabled: n,
              placeholder: "Ex: 2200 ou 1850",
              className: `px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent flex-1 min-w-0 ${n ? "bg-gray-100 text-gray-400 cursor-not-allowed" : "bg-white text-gray-900"}`
            }
          ),
          /* @__PURE__ */ l.jsx(
            "button",
            {
              onClick: le,
              disabled: n || !d.trim(),
              className: `px-2 py-2 text-sm rounded-md transition-colors flex items-center justify-center flex-shrink-0 ${n || !d.trim() ? "bg-gray-100 text-gray-400 cursor-not-allowed" : "bg-green-500 text-white hover:bg-green-600"}`,
              title: "Confirmar filtro de largura",
              children: /* @__PURE__ */ l.jsx("svg", { className: "w-4 h-4", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: /* @__PURE__ */ l.jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M5 13l4 4L19 7" }) })
            }
          ),
          t.largura && /* @__PURE__ */ l.jsx(
            "button",
            {
              onClick: h,
              className: "px-2 py-2 text-sm text-gray-600 hover:text-gray-800 hover:bg-gray-200 rounded-md transition-colors flex-shrink-0",
              title: "Limpar filtro de largura",
              children: /* @__PURE__ */ l.jsx("svg", { className: "w-4 h-4", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: /* @__PURE__ */ l.jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M6 18L18 6M6 6l12 12" }) })
            }
          )
        ] })
      ] })
    ] }),
    ee && !n && /* @__PURE__ */ l.jsx("div", { className: "mt-3 pt-3 border-t border-gray-200", children: /* @__PURE__ */ l.jsxs("div", { className: "flex flex-wrap gap-2 items-center", children: [
      /* @__PURE__ */ l.jsx("span", { className: "text-xs text-gray-600", children: "Filtros ativos:" }),
      t.vendedor && /* @__PURE__ */ l.jsxs("span", { className: "inline-flex items-center gap-1 px-2 py-1 text-xs bg-blue-100 text-blue-800 rounded-md", children: [
        "Vendedor: ",
        t.vendedor,
        o?.profile_type !== "vendedor" && /* @__PURE__ */ l.jsx(
          "button",
          {
            onClick: () => M(""),
            className: "hover:text-blue-600",
            title: "Remover filtro de vendedor",
            children: /* @__PURE__ */ l.jsx("svg", { className: "w-3 h-3", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: /* @__PURE__ */ l.jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M6 18L18 6M6 6l12 12" }) })
          }
        ),
        o?.profile_type === "vendedor" && /* @__PURE__ */ l.jsx("span", { className: "text-blue-600", title: "Filtro obrigatório para usuários limitados", children: "🔒" })
      ] }),
      t.cliente && /* @__PURE__ */ l.jsxs("span", { className: "inline-flex items-center gap-1 px-2 py-1 text-xs bg-green-100 text-green-800 rounded-md", children: [
        "Cliente: ",
        t.cliente,
        /* @__PURE__ */ l.jsx(
          "button",
          {
            onClick: () => Z(""),
            className: "hover:text-green-600",
            title: "Remover filtro de cliente",
            children: /* @__PURE__ */ l.jsx("svg", { className: "w-3 h-3", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: /* @__PURE__ */ l.jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M6 18L18 6M6 6l12 12" }) })
          }
        )
      ] }),
      t.espessura && /* @__PURE__ */ l.jsxs("span", { className: "inline-flex items-center gap-1 px-2 py-1 text-xs bg-purple-100 text-purple-800 rounded-md", children: [
        "Espessura: ",
        t.espessura,
        /* @__PURE__ */ l.jsx(
          "button",
          {
            onClick: we,
            className: "hover:text-purple-600",
            title: "Remover filtro de espessura",
            children: /* @__PURE__ */ l.jsx("svg", { className: "w-3 h-3", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: /* @__PURE__ */ l.jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M6 18L18 6M6 6l12 12" }) })
          }
        )
      ] }),
      t.largura && /* @__PURE__ */ l.jsxs("span", { className: "inline-flex items-center gap-1 px-2 py-1 text-xs bg-orange-100 text-orange-800 rounded-md", children: [
        "Largura: ",
        t.largura,
        " mm",
        /* @__PURE__ */ l.jsx(
          "button",
          {
            onClick: h,
            className: "hover:text-orange-600",
            title: "Remover filtro de largura",
            children: /* @__PURE__ */ l.jsx("svg", { className: "w-3 h-3", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: /* @__PURE__ */ l.jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M6 18L18 6M6 6l12 12" }) })
          }
        )
      ] })
    ] }) })
  ] }) });
}, gs = (e) => {
  const [t, r] = Y({
    vendedor: "",
    cliente: "",
    espessura: "",
    largura: ""
  }), n = q(() => {
    const i = /* @__PURE__ */ new Set(), a = /* @__PURE__ */ new Set();
    return e.forEach((d) => {
      d.deliveries.forEach((c) => {
        c.no_vendedor && c.no_vendedor.trim() && i.add(c.no_vendedor.trim()), c.cli_razao_social && c.cli_razao_social.trim() && a.add(c.cli_razao_social.trim());
      });
    }), {
      vendedores: Array.from(i).sort((d, c) => d.localeCompare(c, "pt-BR")),
      clientes: Array.from(a).sort((d, c) => d.localeCompare(c, "pt-BR"))
    };
  }, [e]), o = q(() => n.vendedores.length === 0 && n.clientes.length === 0, [n]), s = q(() => !t.vendedor && !t.cliente && !t.espessura && !t.largura ? e : e.map((i) => ({
    ...i,
    deliveries: i.deliveries.filter((a) => {
      if (t.vendedor) {
        const d = (a.no_vendedor || "").trim(), c = t.vendedor.trim();
        if (d !== c)
          return !1;
      }
      if (t.cliente) {
        const d = (a.cli_razao_social || "").trim(), c = t.cliente.trim();
        if (d !== c)
          return !1;
      }
      if (t.espessura) {
        const d = a.prd_espessura, c = t.espessura.trim();
        if (typeof d == "number") {
          const f = d.toString();
          if (f !== c) {
            const u = f.split(".")[0], p = c.split(".")[0];
            if (u !== p)
              return !1;
          }
        } else
          return !1;
      }
      if (t.largura) {
        const d = a.prd_largura, c = t.largura.trim();
        if (typeof d == "number") {
          const f = d.toString();
          if (f !== c) {
            const u = f.split(".")[0], p = c.split(".")[0];
            if (u !== p)
              return !1;
          }
        } else
          return !1;
      }
      return !0;
    })
  })), [e, t]);
  return {
    filterOptions: n,
    activeFilters: t,
    setActiveFilters: r,
    filteredMonthState: s,
    isLoadingFilters: o
  };
}, ps = (e, t, r) => {
  const [n, o] = Y([]), [s, i] = Y([]), [a, d] = Y(!1), [c, f] = Y(null), u = te(async (_, D) => {
    d(!0), f(null);
    try {
      const N = window.location.hostname === "localhost" ? "http://localhost:8080/api" : "https://dexcobackend-v1-production.up.railway.app/api", T = new URLSearchParams({
        no_vendedor: _
      });
      D ? (T.append("uuid", D), console.log(`📊 [SELLER QUOTAS] Including UUID in API call: ${D}`)) : console.log("⚠️ [SELLER QUOTAS] No UUID provided for quota API call");
      const A = `${N}/get_sellers_cota/?${T.toString()}`;
      console.log(`📞 [SELLER QUOTAS] API call URL: ${A}`);
      const k = await fetch(
        A,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json"
          }
        }
      );
      if (!k.ok)
        throw new Error(`Erro ao buscar cotas: ${k.status}`);
      const M = await k.json();
      if (M.status === "success")
        o(M.data), console.log(`📊 [SELLER QUOTAS] Loaded ${M.data.length} seller quotas for: ${_}`);
      else
        throw new Error(M.message || "Erro desconhecido ao buscar cotas");
    } catch (N) {
      const T = N instanceof Error ? N.message : "Erro desconhecido";
      f(T), console.error("Erro ao buscar cotas do vendedor:", N);
    } finally {
      d(!1);
    }
  }, []), p = te(async (_) => {
    d(!0), f(null);
    try {
      const D = window.location.hostname === "localhost" ? "http://localhost:8080/api" : "https://dexcobackend-v1-production.up.railway.app/api";
      if (!_)
        throw console.log("⚠️ [SUMMARY QUOTAS] No UUID provided for summary quota API call"), new Error("UUID é obrigatório para buscar cotas totais");
      const N = `${D}/get_sellers_cota/summary/?uuid=${_}`;
      console.log(`📞 [SUMMARY QUOTAS] API call URL: ${N}`);
      const T = await fetch(
        N,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json"
          }
        }
      );
      if (!T.ok)
        throw new Error(`Erro ao buscar cotas totais: ${T.status}`);
      const A = await T.json();
      if (A.status === "success")
        i(A.data), console.log(`📊 [SUMMARY QUOTAS] Loaded ${A.data.length} total quotas`);
      else
        throw new Error(A.message || "Erro desconhecido ao buscar cotas totais");
    } catch (D) {
      const N = D instanceof Error ? D.message : "Erro desconhecido";
      f(N), console.error("Erro ao buscar cotas totais:", D);
    } finally {
      d(!1);
    }
  }, []);
  F(() => {
    e && e.profile_type === "vendedor" && e.full_name ? (u(e.full_name, t), i([])) : e && e.profile_type === "diretor" && t ? r && r.trim() !== "" ? (console.log(`📊 [QUOTA LOGIC] Director with vendor filter: "${r}"`), u(r, t), i([])) : (console.log("📊 [QUOTA LOGIC] Director without vendor filter - fetching summary quotas"), p(t), o([])) : (o([]), i([]));
  }, [e, t, r, u, p]);
  const m = te((_) => {
    const D = n.find((N) => N.date === _);
    return D ? D.quota : null;
  }, [n]), S = te((_) => {
    const D = s.find((N) => N.date === _);
    return D ? D.quota : null;
  }, [s]), g = te((_) => m(_) || S(_), [m, S]), b = te((_, D) => {
    const N = g(_);
    return N !== null && D > N;
  }, [g]), E = te(() => s.length > 0 && n.length === 0, [s, n]);
  return {
    quotas: n,
    summaryQuotas: s,
    loading: a,
    error: c,
    getQuotaForDate: g,
    getSellerQuotaForDate: m,
    getSummaryQuotaForDate: S,
    isColumnOverQuota: b,
    isUsingSummaryQuotas: E,
    fetchSummaryQuotas: (_) => p(_),
    refetch: () => {
      e && e.profile_type === "vendedor" && e.full_name ? u(e.full_name, t) : e && e.profile_type === "diretor" && t && (r && r.trim() !== "" ? u(r, t) : p(t));
    }
  };
}, hs = (e, t) => {
  const r = t.filter(
    (o) => o.id.startsWith(`${e}-`) && o.id !== e
  );
  let n = 0;
  return r.forEach((o) => {
    const s = o.id.match(`^${e}-(\\d+)$`);
    if (s) {
      const i = parseInt(s[1], 10);
      i > n && (n = i);
    }
  }), `${e}-${n + 1}`;
}, ms = (e, t) => {
  switch (t.type) {
    case "MOVE_CARD": {
      const r = [...e];
      if (!r[t.fromDay] || !r[t.toDay] || !r[t.fromDay].deliveries[t.fromIndex])
        return console.warn("Invalid indices in MOVE_CARD action:", t), e;
      const n = r[t.fromDay].deliveries[t.fromIndex];
      r[t.fromDay] = {
        ...r[t.fromDay],
        deliveries: r[t.fromDay].deliveries.filter((s, i) => i !== t.fromIndex)
      };
      const o = [...r[t.toDay].deliveries];
      return o.splice(t.toIndex, 0, n), r[t.toDay] = {
        ...r[t.toDay],
        deliveries: o
      }, r;
    }
    case "REORDER_CARDS": {
      const r = [...e];
      return !r[t.dayIndex] || !r[t.dayIndex].deliveries[t.oldIndex] || t.newIndex < 0 || t.newIndex > r[t.dayIndex].deliveries.length ? (console.warn("Invalid indices in REORDER_CARDS action:", t, "Array length:", r[t.dayIndex]?.deliveries?.length), e) : (r[t.dayIndex] = {
        ...r[t.dayIndex],
        deliveries: nr(r[t.dayIndex].deliveries, t.oldIndex, t.newIndex)
      }, r);
    }
    case "SET_MONTH":
      return t.month;
    case "SPLIT_CARD": {
      const r = [...e], { dayIndex: n, cardIndex: o, originalCard: s, newSize: i } = t, a = Math.round((s.units - i) * 100) / 100, d = r.flatMap((p) => p.deliveries), c = {
        ...s,
        qt_vol_m3_liquido_gerencial: a,
        units: a
      }, f = {
        ...s,
        id: hs(s.id, d),
        // Generate incremental ID for split card
        parent_id: s.id,
        // Reference to original card
        qt_vol_m3_liquido_gerencial: i,
        units: i
      }, u = [...r[n].deliveries];
      return u[o] = c, u.splice(o + 1, 0, f), r[n] = {
        ...r[n],
        deliveries: u
      }, r;
    }
    default:
      return e;
  }
}, Cs = ({
  month: e,
  monthName: t,
  maxUnits: r,
  onScheduleChange: n,
  initialWeek: o = 0,
  onFiltersChange: s,
  userInfo: i,
  onShowToast: a,
  taskId: d
}) => {
  const [c, f] = Cr(ms, e), [u, p] = Y(null), [m, S] = Y(null), [g, b] = Y(o), [E, _] = Y(60), [D, N] = Y(null), [T, A] = Y(!1), k = /* @__PURE__ */ new Date(), [M, Z] = Y(k.getFullYear()), [y, j] = Y(k.getMonth()), [G, oe] = Y(null), ne = J(null), me = J(null), we = J(null), se = J(null), Ee = J(!1), le = te((v) => {
    se.current && clearTimeout(se.current), se.current = setTimeout(() => {
      v !== E && v > 0 && _(v);
    }, 100);
  }, [E]);
  F(() => () => {
    se.current && clearTimeout(se.current);
  }, []);
  const {
    filterOptions: h,
    activeFilters: P,
    setActiveFilters: B,
    filteredMonthState: ee,
    isLoadingFilters: C
  } = gs(c), { getQuotaForDate: z, isColumnOverQuota: ce } = ps(i, d, P.vendedor);
  F(() => {
    s && s(P);
  }, [P, s]);
  const ve = q(() => {
    const v = new Date(M, y, 1), w = new Date(v);
    w.setDate(v.getDate() - v.getDay());
    const x = [], I = new Date(w);
    for (let X = 0; X < 35; X++) {
      const O = or(I);
      x.push({
        date: O,
        deliveries: []
      }), I.setDate(I.getDate() + 1);
    }
    return x;
  }, [M, y]), U = q(() => {
    const v = {};
    return ee.forEach((w) => {
      w.deliveries.length > 0 && (v[w.date] = w.deliveries);
    }), ve.map((w) => ({
      ...w,
      deliveries: v[w.date] || []
    }));
  }, [ve, ee]), W = q(() => {
    if (U.length === 0)
      return [];
    const v = [];
    for (let w = 0; w < 5; w++) {
      const x = w * 7, I = U.slice(x, x + 7);
      I.length === 7 && v.push(I);
    }
    return v;
  }, [U]), $ = W[g] || [], Ae = jn(
    Yt(Br, {
      activationConstraint: {
        distance: 8
        // Prevent accidental drags on desktop
      }
    }),
    Yt(Vr, {
      activationConstraint: {
        delay: 250,
        // Wait for 250ms to distinguish from scrolling
        tolerance: 8
        // Allow 8px movement during delay
      }
    }),
    Yt(er, {
      coordinateGetter: ss
    })
  ), ge = q(() => {
    if (r) return r;
    if (!$ || $.length === 0)
      return 100;
    const v = $.filter((x) => x && x.deliveries).map(
      (x) => x.deliveries.filter((I) => I && typeof I.units == "number").reduce((I, X) => I + X.units, 0)
    ).filter((x) => typeof x == "number" && !isNaN(x)), w = v.length > 0 ? Math.max(...v, 100) : 100;
    return Math.ceil(w / 50) * 50;
  }, [$, r]), Ie = q(() => {
    if (!u) return null;
    if (m) return m;
    for (const v of $)
      if (v && v.deliveries) {
        const w = v.deliveries.find((x) => x && x.id && x.id === u);
        if (w) return w;
      }
    for (const v of c)
      if (v && v.deliveries) {
        const w = v.deliveries.find((x) => x && x.id && x.id === u);
        if (w) return w;
      }
    return null;
  }, [u, m, $, c]), Se = (v) => {
    const w = v.active.id;
    p(w);
    let x = null;
    for (const I of c)
      if (I && I.deliveries) {
        const X = I.deliveries.find((O) => O && O.id && O.id === w);
        if (X) {
          x = X;
          break;
        }
      }
    S(x);
  }, Le = (v) => {
    try {
      const w = new Date(v), x = kt();
      return w < x;
    } catch (w) {
      return console.warn("Error parsing date for validation:", w), !1;
    }
  }, $e = (v) => {
    if (!i || i.profile_type === "diretor")
      return !0;
    if (i.profile_type === "vendedor") {
      const w = i.full_name.toLowerCase(), x = v.no_vendedor?.toLowerCase() || "";
      return w === x || w.includes(x) || x.includes(w);
    }
    return !1;
  }, Ge = (v, w) => {
    if (Le(w))
      return a?.("Não é possível mover cards para datas anteriores à hoje", "warning"), !1;
    if (!$e(v))
      return a?.("Você só pode modificar cards do seu próprio vendedor", "error"), !1;
    if (i?.profile_type === "vendedor") {
      const x = z(w);
      if (x !== null) {
        const I = c.find((R) => R.date === w), X = i.full_name.toLowerCase(), O = I?.deliveries.filter((R) => {
          if (!R || typeof R.units != "number") return !1;
          const L = R.no_vendedor?.toLowerCase() || "";
          return X === L || X.includes(L) || L.includes(X);
        }).reduce((R, L) => R + L.units, 0) || 0, Q = O + v.units;
        if (Q > x)
          return a?.(`Operação bloqueada: limite de ${x.toFixed(2)} m³ seria excedido (atual: ${O.toFixed(2)} m³ + ${v.units.toFixed(2)} m³ = ${Q.toFixed(2)} m³)`, "warning"), !1;
      }
    }
    return !0;
  }, yt = (v) => {
    p(null), S(null), Pe();
    const { active: w, over: x } = v;
    if (!x) return;
    const I = w.id, X = x.id;
    let O = -1, Q = -1, R = m;
    for (let L = 0; L < c.length; L++)
      if (c[L] && c[L].deliveries) {
        const re = c[L].deliveries.findIndex((V) => !V || !V.id ? !1 : (V.id || `temp-${V.ordem}-${V.item}`) === I);
        if (re !== -1) {
          if (O = L, Q = re, !R) {
            const V = c[L].deliveries[re];
            V && V.id && typeof V.units == "number" && (R = V);
          }
          break;
        }
      }
    if (!R || O === -1 || !R.id || typeof R.units != "number") {
      console.warn("Invalid card data during drag operation:", { card: R, sourceDay: O, activeId: I });
      return;
    }
    if (X.startsWith("day-")) {
      const L = parseInt(X.split("-")[1]), re = W[g];
      if (!re || !re[L]) return;
      const V = re[L].date;
      if (!Ge(R, V))
        return;
      let H = c.findIndex((fe) => fe.date === V);
      if (H === -1) {
        const fe = {
          date: V,
          deliveries: []
        }, pe = new Date(V);
        let xe = c.length;
        for (let ae = 0; ae < c.length; ae++)
          if (new Date(c[ae].date) > pe) {
            xe = ae;
            break;
          }
        const be = [...c];
        be.splice(xe, 0, fe), H = xe, O >= xe && (O += 1), f({ type: "SET_MONTH", month: be }), setTimeout(() => {
          f({
            type: "MOVE_CARD",
            fromDay: O,
            toDay: H,
            fromIndex: Q,
            toIndex: 0
            // Add to bottom (end of array) since cards stack top-to-bottom
          });
        }, 10);
        return;
      }
      if (H !== O) {
        if (!Ge(R, V))
          return;
        const fe = w.rect.current.translated, pe = x.rect;
        let xe = c[H].deliveries.length;
        if (fe && pe) {
          const de = fe.top + fe.height / 2 - pe.top - 60 - 8, he = pe.height - 60 - 8 * 2, ie = Math.max(0, Math.min(he, de)), _e = c[H].deliveries;
          if (_e.length > 0) {
            let Ce = 0, Ne = 0;
            for (let je = 0; je < _e.length; je++) {
              const Te = _e[je];
              if (!Te || typeof Te.units != "number") continue;
              const Fe = _e.filter((at) => at && typeof at.units == "number").reduce((at, sn) => at + sn.units, 0), et = he - 16;
              let st;
              Fe <= ge ? st = Te.units / ge * et : st = Te.units / Fe * et, st = Math.max(20, st);
              const ar = Ce + st + 4;
              if (ie <= ar) {
                Ne = je;
                break;
              }
              Ce = ar, Ne = je + 1;
            }
            xe = Ne;
          } else
            xe = 0;
        }
        f({
          type: "MOVE_CARD",
          fromDay: O,
          toDay: H,
          fromIndex: Q,
          toIndex: xe
        });
      }
    } else
      for (let L = 0; L < c.length; L++)
        if (c[L] && c[L].deliveries) {
          const re = c[L].deliveries.findIndex((V) => !V || !V.id ? !1 : (V.id || `temp-${V.ordem}-${V.item}`) === X);
          if (re !== -1) {
            const V = L;
            if (V === O) {
              if (!$e(R)) {
                a?.("Você só pode modificar cards do seu próprio vendedor", "error");
                return;
              }
              f({
                type: "REORDER_CARDS",
                dayIndex: O,
                oldIndex: Q,
                newIndex: re
              });
            } else {
              const H = c[V].date;
              if (!Ge(R, H))
                return;
              f({
                type: "MOVE_CARD",
                fromDay: O,
                toDay: V,
                fromIndex: Q,
                toIndex: re
              });
            }
            break;
          }
        }
  }, He = te((v) => {
    if (!u || !we.current) return;
    const w = we.current, x = w.getBoundingClientRect(), I = v.clientX - x.left, X = v.clientY - x.top, O = 200, Q = 60, R = I - O / 2, L = I + O / 2, re = X - Q / 2, V = X + Q / 2, H = 500;
    let fe = !1, pe = !1;
    const xe = w.querySelector("#nav-left-button"), be = w.querySelector("#nav-right-button");
    if (xe && g > 0) {
      const de = xe.getBoundingClientRect(), he = w.getBoundingClientRect(), ie = de.top - he.top - 10, _e = de.bottom - he.top + 10, Ce = de.left - he.left - 10, Ne = de.right - he.left + 10, je = L >= Ce && R <= Ne, Te = V >= ie && re <= _e;
      je && Te && (fe = !0);
    }
    if (be && g < W.length - 1) {
      const de = be.getBoundingClientRect(), he = w.getBoundingClientRect(), ie = de.top - he.top - 10, _e = de.bottom - he.top + 10, Ce = de.left - he.left - 10, Ne = de.right - he.left + 10, je = L >= Ce && R <= Ne, Te = V >= ie && re <= _e;
      je && Te && (pe = !0);
    }
    let ae = null;
    fe ? ae = "left" : pe && (ae = "right"), me.current && (clearTimeout(me.current), me.current = null), ae ? oe(ae) : me.current = setTimeout(() => {
      oe(null);
    }, 100), ne.current && (clearTimeout(ne.current), ne.current = null), ae && (ne.current = setTimeout(() => {
      const de = u, he = m;
      ae === "left" && g > 0 ? b((ie) => ie - 1) : ae === "right" && g < W.length - 1 && b((ie) => ie + 1), setTimeout(() => {
        de && he && (p(de), S(he));
      }, 50), oe(null);
    }, H));
  }, [u, g, W.length, m]), Pe = te(() => {
    ne.current && (clearTimeout(ne.current), ne.current = null), me.current && (clearTimeout(me.current), me.current = null), oe(null);
  }, []), Qe = te((v) => {
    N(v), A(!0);
  }, []), Je = te(() => {
    A(!1), N(null);
  }, []), wt = te((v, w) => {
    for (let x = 0; x < c.length; x++) {
      const I = c[x].deliveries.findIndex(
        (X) => {
          const O = X.id || `temp-${X.ordem}-${X.item}`, Q = v.id || `temp-${v.ordem}-${v.item}`;
          return O === Q;
        }
      );
      if (I !== -1) {
        f({
          type: "SPLIT_CARD",
          dayIndex: x,
          cardIndex: I,
          originalCard: v,
          newSize: w
        });
        break;
      }
    }
  }, [c]), Dt = te((v, w) => {
    let x = -1, I = -1;
    for (let R = 0; R < c.length; R++) {
      const L = c[R].deliveries.findIndex(
        (re) => re.id === v.id
      );
      if (L !== -1) {
        x = R, I = L;
        break;
      }
    }
    if (x === -1)
      return;
    const X = {
      ...v,
      dt_producao: is(w)
      // Update production date - this controls positioning
      // dt_desejada_remessa remains unchanged - now it's informational only
    }, O = [...c];
    O[x] = {
      ...O[x],
      deliveries: O[x].deliveries.map(
        (R, L) => L === I ? X : R
      )
    };
    let Q = O.findIndex((R) => R.date === w);
    if (Q === -1) {
      const R = {
        date: w,
        deliveries: []
      }, L = new Date(w);
      let re = O.length;
      for (let V = 0; V < O.length; V++)
        if (new Date(O[V].date) > L) {
          re = V;
          break;
        }
      O.splice(re, 0, R), Q = re, x >= re && (x += 1), f({ type: "SET_MONTH", month: O }), setTimeout(() => {
        f({
          type: "MOVE_CARD",
          fromDay: x,
          toDay: Q,
          fromIndex: I,
          toIndex: 0
        });
      }, 10);
    } else
      f({ type: "SET_MONTH", month: O }), setTimeout(() => {
        f({
          type: "MOVE_CARD",
          fromDay: x,
          toDay: Q,
          fromIndex: I,
          toIndex: O[Q].deliveries.length
          // Add to end
        });
      }, 10);
    A(!1), N(null);
  }, [c]), Bt = q(() => {
    const v = U.map((R) => R.date), w = new Set(v), x = v.sort((R, L) => new Date(R).getTime() - new Date(L).getTime()), I = x[0], X = x[x.length - 1], O = new Date(I);
    for (let R = 1; R <= 30; R++) {
      const L = new Date(O);
      L.setDate(O.getDate() - R);
      const re = L.getFullYear(), V = String(L.getMonth() + 1).padStart(2, "0"), H = String(L.getDate()).padStart(2, "0");
      w.add(`${re}-${V}-${H}`);
    }
    const Q = new Date(X);
    for (let R = 1; R <= 30; R++) {
      const L = new Date(Q);
      L.setDate(Q.getDate() + R);
      const re = L.getFullYear(), V = String(L.getMonth() + 1).padStart(2, "0"), H = String(L.getDate()).padStart(2, "0");
      w.add(`${re}-${V}-${H}`);
    }
    return Array.from(w).sort((R, L) => new Date(R).getTime() - new Date(L).getTime());
  }, [U]), Vt = q(() => {
    if (!D) return "";
    for (const v of U)
      if (v && v.deliveries && v.deliveries.some((x) => x && x.id && x.id === D.id))
        return v.date;
    return Ve(D.dt_producao);
  }, [D, U]);
  F(() => {
    b(0);
  }, [y, M]), F(() => {
    if (u)
      return document.addEventListener("pointermove", He), () => {
        document.removeEventListener("pointermove", He);
      };
  }, [u, He]), F(() => {
    Ee.current = !0, f({ type: "SET_MONTH", month: e }), Promise.resolve().then(() => {
      Ee.current = !1;
    });
  }, [e]), F(() => {
    n && !Ee.current && n(c);
  }, [c, n]);
  const ze = 500, Ue = (ge > 700 ? Math.max(ze, ge * 0.8) : ze) + 140;
  return /* @__PURE__ */ l.jsxs("div", { className: "bg-white rounded-lg shadow-lg relative", children: [
    /* @__PURE__ */ l.jsx("div", { className: "border-b border-gray-200 p-3 sm:p-4 flex-shrink-0", children: /* @__PURE__ */ l.jsxs("div", { className: "flex flex-col sm:flex-row justify-between items-center gap-3", children: [
      /* @__PURE__ */ l.jsxs("div", { className: "flex items-center gap-3 flex-wrap", children: [
        /* @__PURE__ */ l.jsx("h2", { className: "text-base sm:text-lg font-semibold text-gray-800", children: W.length > 0 && W[g]?.length > 0 ? (() => {
          const v = W[g][0].date, w = W[g][W[g].length - 1].date, x = (L) => {
            const [re, V, H] = L.split("-").map(Number);
            return new Date(re, V - 1, H);
          }, I = x(v), X = x(w), O = I.toLocaleDateString("en-US", { month: "short", day: "numeric" }), Q = X.toLocaleDateString("en-US", { month: "short", day: "numeric" }), R = I.toLocaleDateString("en-US", { month: "long", year: "numeric" });
          return v === w ? `${O} - ${R}` : `${O} - ${Q} | ${R}`;
        })() : t }),
        /* @__PURE__ */ l.jsxs("div", { className: "flex items-center gap-1 sm:gap-2 flex-wrap", children: [
          /* @__PURE__ */ l.jsx(
            "select",
            {
              value: y,
              onChange: (v) => j(parseInt(v.target.value)),
              className: "px-1 sm:px-2 py-1 text-xs sm:text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent",
              children: Array.from({ length: 12 }, (v, w) => {
                const x = new Date(2024, w, 1).toLocaleDateString("en-US", { month: "long" });
                return /* @__PURE__ */ l.jsx("option", { value: w, children: x }, w);
              })
            }
          ),
          /* @__PURE__ */ l.jsx(
            "select",
            {
              value: M,
              onChange: (v) => Z(parseInt(v.target.value)),
              className: "px-1 sm:px-2 py-1 text-xs sm:text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent",
              children: Array.from({ length: 5 }, (v, w) => {
                const x = k.getFullYear() - 1 + w;
                return /* @__PURE__ */ l.jsx("option", { value: x, children: x }, x);
              })
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ l.jsx("div", { className: "flex flex-wrap gap-2 max-w-full", children: W.map((v, w) => {
        const x = `Semana ${w + 1}`;
        return /* @__PURE__ */ l.jsx(
          "button",
          {
            onClick: () => b(w),
            className: "px-2 sm:px-3 py-1 sm:py-2 text-xs sm:text-sm font-medium rounded-lg transition-all duration-200 flex-shrink-0 shadow-sm",
            style: {
              backgroundColor: g === w ? "#059669" : "#ffffff",
              color: g === w ? "#ecfdf5" : "#374151",
              border: g === w ? "none" : "1px solid #d1d5db",
              boxShadow: g === w ? "0 4px 6px -1px rgba(0, 0, 0, 0.1)" : "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
              transform: g === w ? "scale(1.05)" : "scale(1)",
              transition: "all 0.2s ease"
            },
            onMouseEnter: (I) => {
              g === w ? I.currentTarget.style.backgroundColor = "#047857" : (I.currentTarget.style.backgroundColor = "#ecfdf5", I.currentTarget.style.borderColor = "#10b981", I.currentTarget.style.color = "#047857");
            },
            onMouseLeave: (I) => {
              g === w ? I.currentTarget.style.backgroundColor = "#059669" : (I.currentTarget.style.backgroundColor = "#ffffff", I.currentTarget.style.borderColor = "#d1d5db", I.currentTarget.style.color = "#374151");
            },
            children: x
          },
          w
        );
      }) })
    ] }) }),
    /* @__PURE__ */ l.jsx(
      fs,
      {
        filterOptions: h,
        activeFilters: P,
        onFiltersChange: B,
        isLoading: C,
        userInfo: i,
        onShowToast: a
      }
    ),
    /* @__PURE__ */ l.jsxs(
      No,
      {
        sensors: Ae,
        collisionDetection: Rr,
        onDragStart: Se,
        onDragEnd: yt,
        children: [
          /* @__PURE__ */ l.jsx("div", { className: "flex flex-row", children: /* @__PURE__ */ l.jsx("div", { className: "chart-responsive-wrapper", children: /* @__PURE__ */ l.jsxs(
            "div",
            {
              className: "flex flex-col",
              ref: we,
              style: {
                // Dynamic minimum width based on number of columns
                minWidth: `${Math.max($.length * 160, 320)}px`,
                // Min 160px per column, absolute min 320px
                width: "100%"
              },
              children: [
                u && /* @__PURE__ */ l.jsxs("div", { className: "border-b border-gray-200 bg-gray-50 p-3 sm:p-4 flex-shrink-0 mb-3", children: [
                  /* @__PURE__ */ l.jsxs("div", { className: "flex gap-2", children: [
                    g > 0 && /* @__PURE__ */ l.jsxs(
                      "div",
                      {
                        id: "nav-left-button",
                        className: `flex-1 flex items-center justify-center space-x-2 px-3 py-3 rounded-lg border-2 border-dashed transition-colors ${G === "left" ? "bg-blue-100 border-blue-300 text-blue-600" : "bg-gray-50 border-gray-300 text-gray-500"}`,
                        children: [
                          /* @__PURE__ */ l.jsx("svg", { className: "w-5 h-5", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: /* @__PURE__ */ l.jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M15 19l-7-7 7-7" }) }),
                          /* @__PURE__ */ l.jsx("span", { className: "text-sm font-medium", children: "Semana Anterior" })
                        ]
                      }
                    ),
                    g < W.length - 1 && /* @__PURE__ */ l.jsxs(
                      "div",
                      {
                        id: "nav-right-button",
                        className: `flex-1 flex items-center justify-center space-x-2 px-3 py-3 rounded-lg border-2 border-dashed transition-colors ${G === "right" ? "bg-blue-100 border-blue-300 text-blue-600" : "bg-gray-50 border-gray-300 text-gray-500"}`,
                        children: [
                          /* @__PURE__ */ l.jsx("span", { className: "text-sm font-medium", children: "Próxima Semana" }),
                          /* @__PURE__ */ l.jsx("svg", { className: "w-5 h-5", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: /* @__PURE__ */ l.jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M9 5l7 7-7 7" }) })
                        ]
                      }
                    )
                  ] }),
                  /* @__PURE__ */ l.jsx("div", { className: "text-xs text-gray-400 text-center mt-2", children: G ? "Solte para navegar" : "Arraste os cards sobre os botões acima para navegar" })
                ] }),
                /* @__PURE__ */ l.jsxs("div", { className: "flex flex-1 relative", children: [
                  /* @__PURE__ */ l.jsx(
                    "div",
                    {
                      className: "chart-y-axis hidden sm:block flex-shrink-0 sticky left-0 z-20",
                      style: {
                        height: `${Ue}px`,
                        overflow: "hidden",
                        width: "64px"
                      },
                      children: /* @__PURE__ */ l.jsx(
                        ds,
                        {
                          maxUnits: ge,
                          height: Ue,
                          headerHeight: E
                        }
                      )
                    }
                  ),
                  /* @__PURE__ */ l.jsxs(
                    "div",
                    {
                      className: "flex-1 relative overflow-x-auto group w-full",
                      style: {
                        height: `${Ue}px`,
                        overflowY: "visible",
                        // Allow content to extend below
                        WebkitOverflowScrolling: "touch",
                        scrollBehavior: "smooth",
                        maxHeight: "none"
                      },
                      tabIndex: 0,
                      "aria-label": "Tabela rolável horizontalmente",
                      children: [
                        /* @__PURE__ */ l.jsx("div", { className: "sm:hidden absolute right-0 top-0 bottom-0 w-8 pointer-events-none z-30 bg-gradient-to-l from-black/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" }),
                        /* @__PURE__ */ l.jsxs(
                          "div",
                          {
                            className: "absolute inset-0 pointer-events-none",
                            style: { zIndex: 0 },
                            children: [
                              /* @__PURE__ */ l.jsx("div", { className: "h-[60px] border-b-2 border-gray-200 bg-gray-50" }),
                              /* @__PURE__ */ l.jsx(
                                "div",
                                {
                                  className: "relative",
                                  style: {
                                    height: `${Ue - 60}px`,
                                    paddingTop: `${E - 60}px`
                                    // Dynamic offset
                                  },
                                  children: (() => {
                                    const v = [];
                                    for (let x = 0; x <= ge; x += 50)
                                      v.push(x);
                                    return v.map((x) => {
                                      const I = ge === 0 ? 0 : x / ge * 100;
                                      return /* @__PURE__ */ l.jsx(
                                        "div",
                                        {
                                          className: "absolute w-full h-px bg-gray-200 opacity-30",
                                          style: {
                                            top: `${100 - I}%`,
                                            transform: "translateY(-50%)"
                                          }
                                        },
                                        x
                                      );
                                    });
                                  })()
                                }
                              )
                            ]
                          }
                        ),
                        /* @__PURE__ */ l.jsx(
                          "div",
                          {
                            className: "chart-columns-container pb-12",
                            style: {
                              minWidth: `${$.length * 160}px`,
                              // Dynamic minimum based on columns
                              height: `${Ue}px`,
                              zIndex: 1
                            },
                            children: $.map((v, w) => {
                              const x = z(v.date);
                              let I, X;
                              if (i?.profile_type === "vendedor") {
                                const O = i.full_name.toLowerCase();
                                I = v.deliveries.filter((Q) => {
                                  if (!Q || typeof Q.units != "number") return !1;
                                  const R = Q.no_vendedor?.toLowerCase() || "";
                                  return O === R || O.includes(R) || R.includes(O);
                                }).reduce((Q, R) => Q + R.units, 0);
                              } else
                                I = v.deliveries.filter((O) => O && typeof O.units == "number").reduce((O, Q) => O + Q.units, 0);
                              return X = ce(v.date, I), /* @__PURE__ */ l.jsx(
                                cs,
                                {
                                  day: v,
                                  dayIndex: w,
                                  maxUnits: ge,
                                  columnHeight: Ue,
                                  onCardClick: Qe,
                                  onHeaderHeightChange: le,
                                  quota: x,
                                  isOverQuota: X,
                                  vendorTotalVolume: i?.profile_type === "vendedor" ? I : void 0
                                },
                                v.date
                              );
                            })
                          }
                        )
                      ]
                    }
                  )
                ] })
              ]
            }
          ) }) }),
          /* @__PURE__ */ l.jsx(Fo, { children: Ie && /* @__PURE__ */ l.jsx(
            nn,
            {
              card: Ie,
              height: 60,
              isDragging: !0
            }
          ) })
        ]
      }
    ),
    D && /* @__PURE__ */ l.jsx(
      us,
      {
        card: D,
        isOpen: T,
        onClose: Je,
        onSplit: wt,
        onDateChange: Dt,
        availableDates: Bt,
        currentColumnDate: Vt,
        userInfo: i,
        onShowToast: a,
        getQuotaForDate: z,
        monthState: c
      }
    )
  ] });
}, vs = (e, t) => q(() => {
  const r = [], n = /* @__PURE__ */ new Date("2025-04-28");
  for (let a = 0; a < 28; a++) {
    const d = new Date(n);
    d.setDate(n.getDate() + a);
    const c = or(d);
    r.push({
      date: c,
      deliveries: []
    });
  }
  const o = t?.maxUnitsPerDay || 1 / 0, s = t?.clientBlackoutDays || {};
  return [...e].sort((a, d) => d.units - a.units).forEach((a) => {
    let d = 0, c = 1 / 0;
    for (let f = 0; f < 28; f++) {
      const u = r[f], p = u.deliveries.reduce((N, T) => N + T.units, 0), m = u.date.split("-"), S = parseInt(m[0]), g = parseInt(m[1]) - 1, b = parseInt(m[2]), _ = new Date(S, g, b).toLocaleDateString("en-US", { weekday: "long" });
      (s[a.client] || []).includes(_) || p + a.units > o || p < c && (c = p, d = f);
    }
    r[d].deliveries.push(a);
  }), r.forEach((a) => {
    a.deliveries.sort((d, c) => c.units - d.units);
  }), r;
}, [e, t]), xs = () => [
  {
    id: "1",
    ordem: "1067864",
    item: "10",
    centro: "D063",
    cli_cod_pai: 12345,
    cli_razao_social: "MOVAL MOVEIS ARAPONGAS LTDA",
    no_vendedor: "OSVALDO UNGARO JUNIOR",
    cd_produto: "10082827",
    prd_dc_linha: "MDP MADEPAN",
    prd_espessura: 12,
    prd_tx_breve: "P MP-SUPIN 12,0 2200 2750 00044",
    qt_vol_m3_liquido_gerencial: 143.75,
    dt_emissao: "2024-09-06",
    dt_desejada_remessa: "2025-01-16",
    dt_producao: "2025-01-16",
    parent_id: "1",
    // Original card has parent_id set to its own ID
    // Computed properties for backward compatibility
    productId: "10082827",
    productName: "P MP-SUPIN 12,0 2200 2750 00044",
    units: 143.75,
    client: "MOVAL MOVEIS ARAPONGAS LTDA"
  },
  {
    id: "2",
    ordem: "1074404",
    item: "20",
    centro: "D063",
    cli_cod_pai: 23456,
    cli_razao_social: "MOVEIS B P LTDA",
    no_vendedor: "GILBERTO EMANUEL LANA E SILVA",
    cd_produto: "10093207",
    prd_dc_linha: "MDP MADEPAN",
    prd_espessura: 15,
    prd_tx_breve: "C MP-CHULL 15,0 1850 2750 00044",
    qt_vol_m3_liquido_gerencial: 26.86,
    dt_emissao: "2024-09-10",
    dt_desejada_remessa: "2025-01-06",
    dt_producao: "2025-01-06",
    parent_id: "2",
    // Original card has parent_id set to its own ID
    // Computed properties for backward compatibility
    productId: "10093207",
    productName: "C MP-CHULL 15,0 1850 2750 00044",
    units: 26.86,
    client: "MOVEIS B P LTDA"
  },
  {
    id: "3",
    ordem: "1081987",
    item: "10",
    centro: "D063",
    cli_cod_pai: 34567,
    cli_razao_social: "MADEMARQUES MOVEIS LTDA",
    no_vendedor: "GILBERTO EMANUEL LANA E SILVA",
    cd_produto: "10084302",
    prd_dc_linha: "MDP MADEPAN",
    prd_espessura: 15,
    prd_tx_breve: "E MP-SUPIN 15,0 2390 2750 00038",
    qt_vol_m3_liquido_gerencial: 7.49,
    dt_emissao: "2024-09-15",
    dt_desejada_remessa: "2025-01-06",
    dt_producao: "2025-01-06",
    parent_id: "3",
    // Original card has parent_id set to its own ID
    // Computed properties for backward compatibility
    productId: "10084302",
    productName: "E MP-SUPIN 15,0 2390 2750 00038",
    units: 7.49,
    client: "MADEMARQUES MOVEIS LTDA"
  },
  {
    id: "4",
    ordem: "1094005",
    item: "20",
    centro: "D063",
    cli_cod_pai: 45678,
    cli_razao_social: "A J RORATO & CIA LTDA",
    no_vendedor: "FABIO COLONETI",
    cd_produto: "10088039",
    prd_dc_linha: "MDP MADEPAN",
    prd_espessura: 12,
    prd_tx_breve: "P MP-SUPIN 12,0 1850 2750 00054",
    qt_vol_m3_liquido_gerencial: 16.48,
    dt_emissao: "2024-09-22",
    dt_desejada_remessa: "2025-01-06",
    dt_producao: "2025-01-06",
    parent_id: "4",
    // Original card has parent_id set to its own ID
    // Computed properties for backward compatibility
    productId: "10088039",
    productName: "P MP-SUPIN 12,0 1850 2750 00054",
    units: 16.48,
    client: "A J RORATO & CIA LTDA"
  },
  {
    id: "5",
    ordem: "1106775",
    item: "10",
    centro: "D063",
    cli_cod_pai: 56789,
    cli_razao_social: "RV MOVEIS LTDA",
    no_vendedor: "FABRICIO DUARTE BASTOS",
    cd_produto: "10082830",
    prd_dc_linha: "MDP MADEPAN",
    prd_espessura: 15,
    prd_tx_breve: "P MP-SUPIN 15,0 2200 2750 00038",
    qt_vol_m3_liquido_gerencial: 155.18,
    dt_emissao: "2024-09-30",
    dt_desejada_remessa: "2025-01-07",
    dt_producao: "2025-01-07",
    parent_id: "5",
    // Original card has parent_id set to its own ID
    // Computed properties for backward compatibility
    productId: "10082830",
    productName: "P MP-SUPIN 15,0 2200 2750 00038",
    units: 155.18,
    client: "RV MOVEIS LTDA"
  },
  {
    id: "6",
    ordem: "1125573",
    item: "10",
    centro: "D063",
    cli_cod_pai: 45678,
    cli_razao_social: "A J RORATO & CIA LTDA",
    no_vendedor: "FABIO COLONETI",
    cd_produto: "10088037",
    prd_dc_linha: "MDP MADEPAN",
    prd_espessura: 15,
    prd_tx_breve: "P MP-SUPIN 15,0 1850 2750 00044",
    qt_vol_m3_liquido_gerencial: 13.43,
    dt_emissao: "2024-10-11",
    dt_desejada_remessa: "2025-01-06",
    dt_producao: "2025-01-06",
    parent_id: "6",
    // Original card has parent_id set to its own ID
    // Computed properties for backward compatibility
    productId: "10088037",
    productName: "P MP-SUPIN 15,0 1850 2750 00044",
    units: 13.43,
    client: "A J RORATO & CIA LTDA"
  },
  {
    id: "7",
    ordem: "1128560",
    item: "10",
    centro: "D063",
    cli_cod_pai: 23456,
    cli_razao_social: "MOVEIS B P LTDA",
    no_vendedor: "GILBERTO EMANUEL LANA E SILVA",
    cd_produto: "10092936",
    prd_dc_linha: "MDP MADEPAN",
    prd_espessura: 15,
    prd_tx_breve: "C MP-CHULL 15,0 2200 2750 00038",
    qt_vol_m3_liquido_gerencial: 17.24,
    dt_emissao: "2024-10-14",
    dt_desejada_remessa: "2025-01-06",
    dt_producao: "2025-01-06",
    parent_id: "7",
    // Original card has parent_id set to its own ID
    // Computed properties for backward compatibility
    productId: "10092936",
    productName: "C MP-CHULL 15,0 2200 2750 00038",
    units: 17.24,
    client: "MOVEIS B P LTDA"
  }
], bs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generateSampleDeliveries: xs,
  useOptimisedSchedule: vs
}, Symbol.toStringTag, { value: "Module" })), Ns = (e, t) => {
  const n = [[
    "id",
    "ordem",
    "item",
    "centro",
    "cli_cod_pai",
    "cli_razao_social",
    "no_vendedor",
    "cd_produto",
    "prd_dc_linha",
    "prd_espessura",
    "prd_tx_breve",
    "qt_vol_m3_liquido_gerencial",
    "dt_emissao",
    "dt_desejada_remessa",
    "dt_producao"
  ].join(",")];
  e.forEach((d) => {
    d.deliveries.forEach((c) => {
      const f = [
        `"${c.id}"`,
        `"${c.ordem}"`,
        `"${c.item}"`,
        `"${c.centro}"`,
        c.cli_cod_pai.toString(),
        `"${c.cli_razao_social}"`,
        `"${c.no_vendedor}"`,
        `"${c.cd_produto}"`,
        `"${c.prd_dc_linha}"`,
        c.prd_espessura.toString(),
        `"${c.prd_tx_breve}"`,
        c.qt_vol_m3_liquido_gerencial.toFixed(2),
        `"${c.dt_emissao}"`,
        `"${c.dt_desejada_remessa}"`,
        `"${c.dt_producao}"`
      ];
      n.push(f.join(","));
    });
  });
  const o = n.join(`
`), s = new Blob([o], { type: "text/csv;charset=utf-8;" }), i = document.createElement("a"), a = URL.createObjectURL(s);
  i.setAttribute("href", a), i.setAttribute("download", `priorização_${t.replace(/\s+/g, "_").toLowerCase()}.csv`), document.body.appendChild(i), i.click(), document.body.removeChild(i);
};
function on(e) {
  const t = e.trim().split(`
`), r = t[0].split(",").map((i) => i.trim().replace(/"/g, "")), n = {
    id: r.indexOf("id"),
    cliCodPai: r.indexOf("cli_cod_pai"),
    cliente: r.indexOf("cli_razao_social"),
    produto: r.indexOf("prd_tx_breve"),
    volume: r.indexOf("qt_vol_m3_liquido_gerencial"),
    emissao: r.indexOf("dt_emissao"),
    desejada: r.indexOf("dt_desejada_remessa"),
    producao: r.indexOf("dt_producao"),
    vendedor: r.indexOf("no_vendedor"),
    ordem: r.indexOf("ordem"),
    item: r.indexOf("item"),
    centro: r.indexOf("centro"),
    codigoProduto: r.indexOf("cd_produto"),
    linhaProduto: r.indexOf("prd_dc_linha"),
    espessura: r.indexOf("prd_espessura"),
    parentId: r.indexOf("parent_id")
  }, o = [];
  for (let i = 1; i < t.length; i++) {
    const a = t[i].split(",").map((p) => p.trim().replace(/"/g, ""));
    if (a.length < r.length) continue;
    const d = (n.desejada >= 0 ? a[n.desejada] : "").trim(), f = (n.producao >= 0 ? a[n.producao] : "").trim() || d;
    if (!f) {
      console.warn(`Row ${i + 1}: Missing both dt_producao and dt_desejada_remessa, skipping`);
      continue;
    }
    const u = {
      id: a[n.id] || `card-${i}`,
      ordem: a[n.ordem] || "",
      item: a[n.item] || "",
      centro: a[n.centro] || "",
      cli_cod_pai: parseInt(a[n.cliCodPai]) || 0,
      cli_razao_social: a[n.cliente] || "Cliente não informado",
      no_vendedor: a[n.vendedor] || "Vendedor não informado",
      cd_produto: a[n.codigoProduto] || "",
      prd_dc_linha: a[n.linhaProduto] || "",
      prd_espessura: parseFloat(a[n.espessura]) || 0,
      prd_tx_breve: a[n.produto] || "Produto não informado",
      qt_vol_m3_liquido_gerencial: parseFloat(a[n.volume]) || 0,
      dt_emissao: a[n.emissao] || (/* @__PURE__ */ new Date()).toISOString(),
      dt_desejada_remessa: d || f,
      // Keep original or use production date as fallback
      dt_producao: f,
      // Primary date for positioning
      parent_id: a[n.parentId] || void 0,
      // Computed properties for compatibility
      productId: a[n.codigoProduto] || "",
      productName: a[n.produto] || "Produto não informado",
      units: parseFloat(a[n.volume]) || 0,
      client: a[n.cliente] || "Cliente não informado"
    };
    o.push(u);
  }
  const s = /* @__PURE__ */ new Map();
  return o.forEach((i) => {
    const a = Ve(i.dt_producao);
    s.has(a) || s.set(a, []), s.get(a).push(i);
  }), Array.from(s.entries()).map(([i, a]) => ({
    date: i,
    deliveries: a.sort((d, c) => d.units - c.units)
  })).sort((i, a) => sr(i.date, a.date));
}
const Es = async () => {
  try {
    const e = await fetch("/payload_example.csv");
    if (!e.ok)
      throw new Error(`Failed to fetch CSV: ${e.statusText}`);
    const t = await e.text(), r = on(t);
    return console.log("Successfully loaded real payload data:", r), r;
  } catch (e) {
    console.error("Failed to load real payload data:", e);
    const { generateSampleDeliveries: t } = await Promise.resolve().then(() => bs), r = t(), n = {};
    r.forEach((s) => {
      const i = s.dt_producao;
      n[i] || (n[i] = []), n[i].push(s);
    });
    const o = Object.entries(n).map(([s, i]) => ({
      date: s,
      deliveries: i.sort((a, d) => d.units - a.units)
    })).sort((s, i) => new Date(s.date).getTime() - new Date(i.date).getTime());
    return console.log("Using fallback sample data:", o), o;
  }
}, Ss = async (e) => {
  try {
    const r = await fetch(e || void 0 || "/api/schedule-data");
    if (!r.ok)
      throw new Error(`API request failed: ${r.statusText}`);
    const n = await r.text();
    return on(n);
  } catch (t) {
    throw console.error("Failed to load data from API:", t), t;
  }
};
function js(e) {
  const t = e.qt_vol_m3_liquido_gerencial.replace(",", "."), r = parseFloat(t), n = Math.round(r * 100) / 100;
  return {
    // Original payload fields
    id: e.id,
    ordem: e.ordem,
    item: e.item,
    centro: e.centro,
    cli_cod_pai: parseInt(e.cli_cod_pai) || 0,
    cli_razao_social: e.cli_razao_social,
    no_vendedor: e.no_vendedor,
    cd_produto: e.cd_produto,
    prd_dc_linha: e.prd_dc_linha,
    prd_espessura: parseFloat(e.prd_espessura),
    prd_tx_breve: e.prd_tx_breve,
    qt_vol_m3_liquido_gerencial: n,
    // Pre-rounded at model level
    dt_emissao: e.dt_emissao,
    dt_desejada_remessa: e.dt_desejada_remessa,
    dt_producao: e.dt_producao,
    parent_id: e.id,
    // Original cards have parent_id set to their own ID
    // Computed/display properties for backward compatibility
    productId: e.cd_produto,
    productName: e.prd_tx_breve,
    units: n,
    // Pre-rounded at model level
    client: e.cli_razao_social
  };
}
function Rs(e) {
  const t = /* @__PURE__ */ new Map();
  return e.forEach((r) => {
    const n = r.dt_producao || r.dt_desejada_remessa;
    if (!n) return;
    const o = Ve(n);
    t.has(o) || t.set(o, []), t.get(o).push(r);
  }), Array.from(t.entries()).map(([r, n]) => ({
    date: r,
    deliveries: n.sort((o, s) => o.units - s.units)
    // Sort by volume
  })).sort((r, n) => sr(r.date, n.date));
}
function As(e) {
  const t = /* @__PURE__ */ new Map();
  return e.forEach((r) => {
    const n = r.dt_producao || r.dt_desejada_remessa;
    if (!n) return;
    const o = Ve(n);
    t.has(o) || t.set(o, []), t.get(o).push(r);
  }), Array.from(t.entries()).map(([r, n]) => ({
    date: r,
    deliveries: n.sort((o, s) => o.units - s.units)
    // Sort by volume
  })).sort((r, n) => sr(r.date, n.date));
}
export {
  ds as Axis,
  us as CardDetailsModal,
  cs as DayColumnComponent,
  nn as DeliveryCardComponent,
  fs as Filters,
  Cs as SalesStackedSchedule,
  sr as compareDates,
  js as convertPayloadToDeliveryCard,
  is as createLocalISOString,
  Ns as exportScheduleToCSV,
  or as formatDateToISO,
  xs as generateSampleDeliveries,
  Ve as getLocalDateString,
  Ds as getProductColor,
  _s as getProductColorHover,
  tn as getThicknessColor,
  rn as getThicknessColorHover,
  As as groupDeliveryCardsByDate,
  Rs as groupDeliveryCardsByProductionDate,
  Ss as loadPayloadFromAPI,
  Es as loadRealPayloadData,
  on as parseCsvData,
  Ke as parseLocalDate,
  gs as useFilters,
  vs as useOptimisedSchedule
};
